// ============================================================================
// EDN Smart Planner — module QCM, statistiques, flashcards et active recall
// ----------------------------------------------------------------------------
// Données : un fichier JSON par item dans qcm/ (sortie du script edn_qcm_scraper.py du dépôt QCM),
// images dans qcm/images/. L'index (quels items ont des QCM) est construit par api.php (action qcm_index)
// et mis en cache dans qcm/index.json ; en secours, qcm/index.json est lu directement.
// Résultats (réponses aux QCM, révisions de flashcards, auto-évaluations d'active recall) : un journal
// unique window.state.learning.log, sauvegardé en local et sur le serveur (actions save_learning/get_learning).
// ============================================================================
(function () {
    'use strict';
    var S = window.state;
    var esc = function (s) { return window.escapeHtml(s == null ? '' : String(s)); };
    // Droits : le serveur vérifie tout ; ici on cache ou verrouille ce qu'on ne peut pas faire.
    var ia = function () { return !!(window.peutIA && window.peutIA()); };
    var admin = function () { return !!(window.estAdmin && window.estAdmin()); };
    var refusIA = function () { S.qcm.notice = { type: 'warn', text: 'Cette fonction IA est réservée aux abonnés.' }; S.qcm.abonnementRequis = true; render(); };

    S.qcm = {
        view: 'list',            // list | item | session | stats | flash | recall
        index: null, indexLoading: false, indexError: null, indexWaiters: [],
        items: {}, loading: {}, loadError: {},
        current: null,           // numéro d'item (string)
        part: null,              // index de sous-partie (null = item entier)
        parts: null,             // sous-parties cochées pour être réunies le temps d'une séance (QCM et flashcards), sinon null
        pedia: false,            // angle « renforcement pédiatrie » : QCM pédiatriques (edn.fr + IA), deck de flashcards dédié
        search: '', sort: 'num', spec: 'all', onlyWithQcm: false,
        filterNotion: null, filterMode: 'all', showAllQuestions: false,
        session: null, flash: null, recall: null,
        chronoIndex: null, busy: '', notice: null
    };
    S.learning = { log: [], decks: {}, partMaps: {}, gaps: {}, cours: {}, rangC: {}, updated: 0 };

    // L'historique, les paquets de flashcards et les répartitions de QCM vivent TOUS dans cette seule ligne, côté
    // serveur — rien n'en est gardé en local. Et save_learning REMPLACE la ligne entière (api.php :
    // ON DUPLICATE KEY UPDATE data_json = VALUES(data_json)), sans historique ni sauvegarde.
    // Donc : tant qu'un get_learning n'a pas RÉUSSI, on n'envoie rien. Sinon un chargement raté suivi d'une seule
    // réponse à un QCM remplace des mois de données par un objet quasi vide, définitivement.
    var learningPret = false, learningAverti = false;
    window.learningPret = function () { return learningPret; };

    // ------------------------------------------------------------------ utilitaires
    var STOP = { les: 1, des: 1, une: 1, dans: 1, pour: 1, avec: 1, chez: 1, sans: 1, sur: 1, par: 1, aux: 1, est: 1, sont: 1, ses: 1, son: 1, leur: 1, leurs: 1, cette: 1, ces: 1, tous: 1, tout: 1, toute: 1, toutes: 1, plus: 1, autres: 1, autre: 1, selon: 1, entre: 1, chez: 1, non: 1, oui: 1, prise: 1, charge: 1, principales: 1, principaux: 1, connaitre: 1, savoir: 1, generalites: 1 };
    function nrm(s) {
        return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function tokens(s) { return nrm(s).split(' ').filter(function (t) { return (t.length >= 4 || (t.length >= 3 && /\d/.test(t))) && !STOP[t]; }); }
    function overlap(a, b) {
        var ta = tokens(a), tb = tokens(b);
        if (!ta.length || !tb.length) return 0;
        var set = {}; ta.forEach(function (t) { set[t] = 1; });
        var shared = 0; tb.forEach(function (t) { if (set[t]) shared++; });
        return shared / Math.min(ta.length, tb.length);
    }
    function shuffle(arr) { for (var i = arr.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = arr[i]; arr[i] = arr[j]; arr[j] = t; } return arr; }
    function pct(x) { return Math.round((x || 0) * 100); }
    function fmtDate(t) { if (!t) return '—'; var d = new Date(t); return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit' }); }
    // QCM d'un item rattachés à un autre item (les QCM de l'item 400 sont travaillés avec l'item 330)
    var ITEM_ALIASES = { '400': '330' };
    function itemMeta(n) {
        var it = null;
        (window.ednsItems || []).some(function (x) { if (String(x.id) === String(n)) { it = x; return true; } return false; });
        return it;
    }
    function itemTitle(n) { var it = itemMeta(n); if (it) return it.titre; var ix = S.qcm.index && S.qcm.index[n]; return ix ? ix.titre : ('Item ' + n); }
    // matière : catalogue du planning, sinon spécialité indiquée par edn.fr (quiz hors programme : sémiologie, radiologie, anapath…)
    function specOf(n) { var it = itemMeta(n); if (it) return it.matiere; var ix = S.qcm.index && S.qcm.index[n]; return (ix && ix.spec) || ''; }
    // items présents dans la banque de QCM mais absents du catalogue des 367 items (quiz transversaux edn.fr)
    // Quiz hors programme : tout ce qui n'est pas un item du catalogue, SAUF les sujets de LCA Pro, qui ont leur
    // propre onglet (lca.js) avec leur article et leurs corrections — les lister ici les proposerait deux fois.
    function extraItems() { var idx = S.qcm.index || {}; return Object.keys(idx).filter(function (n) { return !itemMeta(n) && !(window.estSujetLca && window.estSujetLca(n, idx[n])); }).sort(function (a, b) { return parseInt(a, 10) - parseInt(b, 10); }); }
    // extrait lisible de ce que le serveur a renvoyé quand ce n'est pas du JSON (erreur PHP, page 502, maintenance…)
    function apiSnippet(t) {
        var x = String(t == null ? '' : t).replace(/<script[\s\S]*?<\/script>/gi, ' ').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
        return x ? '« ' + x.slice(0, 240) + (x.length > 240 ? '…' : '') + ' »' : '(réponse vide — le serveur a probablement coupé la requête)';
    }
    function postApi(payload, cb, errCb) {
        fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
            .then(function (r) { if (r && (r.abonnement_requis || r.admin_only)) S.qcm.abonnementRequis = !!r.abonnement_requis; return r.text(); })
            .then(function (t) { var d; try { d = JSON.parse(t); } catch (e) { throw new Error('Réponse serveur non valide. Le serveur a répondu : ' + apiSnippet(t)); } cb(d); })
            .catch(function (e) { if (errCb) errCb(e); else { S.qcm.busy = ''; S.qcm.notice = { type: 'error', text: e.message }; render(); } });
    }
    var TYPE_LABEL = { ONE: 'Réponse unique', MANY_UNDEFINED: 'Réponses multiples', MANY_DEFINED_SHORT: 'Réponses multiples (nombre défini)', MANY_DEFINED_LONG: 'Réponses multiples (nombre défini)', MATCH: 'Réponse à saisir', MATCHING_AREA: 'Zone à pointer sur l\'image', TCS: 'Test de concordance de script' };
    function typeLabel(q) { return TYPE_LABEL[q.methode_reponse] || q.methode_reponse; }
    // Les données edn.fr sont servies par api.php aux sessions connectées (dossier edn_data/ hors public_html) ;
    // le mode « static » (qcm/ dans le site) ne sert que si api.php n'a pas fourni l'index.
    function qcmFileUrl(n, ix) { return S.qcm.source === 'static' ? 'qcm/' + encodeURIComponent(ix.file) : 'api.php?action=qcm_file&item=' + encodeURIComponent(n); }
    // Une annale ouverte ou en cours de séance : ses images sont dans son propre dossier (annales/images/).
    function enAnnale() { return !!(S.qcm.session && S.qcm.session.annale) || S.qcm.view === 'annaleSujet'; }
    function imgUrl(f) {
        f = String(f || '').split('/').pop(); // le scraper note parfois « images/<fichier> »
        if (enAnnale()) return 'api.php?action=annales_image&f=' + encodeURIComponent(f);
        return S.qcm.source === 'static' ? 'qcm/images/' + encodeURIComponent(f) : 'api.php?action=qcm_image&f=' + encodeURIComponent(f);
    }
    window.qcmImageUrl = imgUrl;
    // Deux pages dessinent ce module : QCM, et Training (les sujets d'EDN.fr), qui en réutilise le moteur de séance.
    function surPage() { return S.activeTab === 'qcm' || S.activeTab === 'training'; }
    function render() { if (surPage()) window.renderContent(); sessionSave(); }

    // ------------------------------------------------------------------ séance de QCM conservée
    // Changer d'onglet charge une autre page : la séance en cours est donc mise de côté dans le navigateur (numéros
    // des questions, réponses données, position) et reprise à l'ouverture suivante de l'onglet QCM. Seule la croix
    // « Quitter » (qcmQuit) la termine ; une séance finie n'est pas conservée.
    var SESSION_KEY = 'edn_qcm_session_v1';
    function sessionSave() {
        var s = S.qcm.session; if (!s || !s.list) return;
        if (s.finished) { sessionClear(); return; }
        try {
            localStorage.setItem(SESSION_KEY, JSON.stringify({ n: s.n, annale: s.annale ? { id: s.annale.id, type: s.annale.type, dossier: s.annale.dossier } : undefined, part: s.part, parts: s.parts || undefined, mode: s.mode, pedia: !!S.qcm.pedia, idx: s.idx, ans: s.ans, revealed: !!s.revealed, started: s.started,
                ids: s.list.map(function (q) { return q.id; }), results: s.results.map(function (r) { return { id: r.q && r.q.id, score: r.score, detail: r.detail, ans: r.ans }; }), t: Date.now() }));
        } catch (e) { }
    }
    function sessionClear() { try { localStorage.removeItem(SESSION_KEY); } catch (e) { } }
    function sessionSauvee() { try { return JSON.parse(localStorage.getItem(SESSION_KEY) || 'null'); } catch (e) { return null; } }
    // Reprise : les questions sont retrouvées par identifiant dans le fichier de l'item rechargé.
    window.qcmRestaurerSession = function (cb) {
        var sv = sessionSauvee();
        if (!sv || !sv.n || !Array.isArray(sv.ids) || !sv.ids.length) { S.qcm.reprise = null; if (cb) cb(false); return; }
        if (sv.annale) { annalesReprendre(sv, cb); return; }
        S.qcm.pedia = !!sv.pedia;
        window.loadQcmItem(String(sv.n), function (d) {
            S.qcm.reprise = null;
            if (!d) { sessionClear(); if (cb) cb(false); return; }
            var byId = {}; questionsForPart(d, String(sv.n), null).forEach(function (q) { byId[q.id] = q; });
            var list = sv.ids.map(function (id) { return byId[id]; }).filter(Boolean);
            if (!list.length) { sessionClear(); if (cb) cb(false); return; }
            // séance réunie : le découpage a pu changer depuis, lirePartie écarte les sous-parties disparues
            var reunies = Array.isArray(sv.parts) ? lirePartie(sv.parts, String(sv.n)) : null;
            if (!Array.isArray(reunies)) reunies = null;
            S.qcm.current = String(sv.n); S.qcm.part = reunies ? null : (sv.part == null ? null : sv.part); S.qcm.parts = reunies;
            S.qcm.session = { n: String(sv.n), part: S.qcm.part, parts: reunies || undefined, mode: sv.mode || 'adaptive', list: list, idx: Math.min(sv.idx || 0, list.length - 1), ans: sv.ans == null ? null : sv.ans, revealed: !!sv.revealed, started: sv.started || Date.now(),
                results: (sv.results || []).map(function (r) { return { q: byId[r.id], score: r.score, entry: null, detail: r.detail }; }).filter(function (r) { return r.q; }) };
            S.qcm.view = 'session'; S.qcm.notice = { type: 'info', text: 'Séance reprise là où tu l\'avais laissée. La croix « Quitter » la termine.' };
            if (cb) cb(true);
        });
    };

    // Nettoyage léger du HTML edn.fr : pas de script, images relogées dans qcm/images/
    function cleanHtml(html) {
        if (!html) return '';
        return String(html)
            .replace(/<script[\s\S]*?<\/script>/gi, '')
            // Gestionnaires d'événements avec OU sans guillemets, adresses javascript:, cadres srcdoc : rien de tout
            // cela n'a sa place dans un énoncé. Le contenu vient des exports du scraper, déposés par l'opérateur — ce
            // filtre est une ceinture de plus, pas la seule protection.
            .replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
            .replace(/\s(href|src|action|formaction|xlink:href)\s*=\s*("\s*javascript:[^"]*"|'\s*javascript:[^']*'|javascript:[^\s>]+)/gi, '')
            .replace(/\ssrcdoc\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
            .replace(/<(iframe|object|embed|meta|link|base|form)\b[^>]*>/gi, '')
            .replace(/<img([^>]*?)src=["']images\/([^"']+)["']/gi, function (m, attrs, file) {
                var f = decodeURIComponent(file);
                // Image manquante : le remplacement est fait par le module de la page (écouteur d'erreur en phase
                // de capture sur #qcm-root), pas par un gestionnaire inline recopié dans chaque énoncé.
                return '<img' + attrs + 'class="qcm-img" data-qcm-img="' + esc(f) + '" src="' + imgUrl(f) + '"';
            })
            .replace(/<img(?![^>]*class=)/gi, '<img class="qcm-img"');
    }
    function stripHtml(html) {
        var div = document.createElement('div');
        div.innerHTML = String(html || '').replace(/<script[\s\S]*?<\/script>/gi, '').replace(/<style[\s\S]*?<\/style>/gi, '');
        return (div.textContent || '').replace(/\s+\n/g, '\n').replace(/[ \t]+/g, ' ').trim();
    }

    // ------------------------------------------------------------------ persistance du journal
    var saveTimer = null;
    // Le journal n'a plus de copie dans le navigateur : il vient du serveur (get_learning) et y retourne (save_learning).
    window.loadLearningLocal = function () {
        S.learning.gaps = S.learning.gaps || {}; S.learning.cours = S.learning.cours || {}; S.learning.rangC = S.learning.rangC || {};
    };
    window.mergeLearning = function (remote) {
        if (!remote || !Array.isArray(remote.log)) return false;
        var changed = false, seen = {};
        S.learning.log.forEach(function (e) { seen[e.t + '|' + e.q + '|' + e.m] = 1; });
        remote.log.forEach(function (e) { var k = e.t + '|' + e.q + '|' + e.m; if (!seen[k]) { S.learning.log.push(e); seen[k] = 1; changed = true; } });
        if (changed) S.learning.log.sort(function (a, b) { return a.t - b.t; });
        ['decks', 'partMaps', 'cours'].forEach(function (coll) {
            S.learning[coll] = S.learning[coll] || {};
            Object.keys(remote[coll] || {}).forEach(function (k) {
                var r = remote[coll][k], l = S.learning[coll][k];
                if (!l || (r.updated || 0) > (l.updated || 0)) { S.learning[coll][k] = r; changed = true; }
            });
        });
        S.learning.gaps = S.learning.gaps || {};
        Object.keys(remote.gaps || {}).forEach(function (n) {
            var have = {}; (S.learning.gaps[n] || []).forEach(function (g) { have[g.t + '|' + g.titre] = 1; });
            (remote.gaps[n] || []).forEach(function (g) { if (!have[g.t + '|' + g.titre]) { (S.learning.gaps[n] = S.learning.gaps[n] || []).push(g); changed = true; } });
        });
        S.learning.rangC = S.learning.rangC || {};
        Object.keys(remote.rangC || {}).forEach(function (n) {
            S.learning.rangC[n] = S.learning.rangC[n] || {};
            Object.keys(remote.rangC[n]).forEach(function (k) {
                var r = remote.rangC[n][k], l = S.learning.rangC[n][k];
                if (!l || (r.t || 0) > (l.t || 0)) { S.learning.rangC[n][k] = r; changed = true; } // la décision la plus récente l'emporte
            });
        });
        if (changed) invalidateMastery();
        return changed;
    };
    window.saveLearning = function (localOnly) {
        S.learning.updated = Date.now();
        invalidateMastery();
        if (localOnly) return;
        if (!learningPret) {
            // Les changements restent en mémoire : quand get_learning finira par répondre, mergeLearning les
            // réunira aux données du serveur et c'est CETTE fusion qui sera enregistrée.
            if (!learningAverti) {
                learningAverti = true;
                if (window.toast) window.toast('Historique pas encore chargé : rien n\'est enregistré pour l\'instant, pour ne pas écraser tes données. Recharge la page.', { type: 'danger', duree: 8000 });
            }
            return;
        }
        clearTimeout(saveTimer);
        // inscrit parmi les envois en attente : un changement de page l'expédie avant de partir (window.flushEnAttente)
        var envoyer = function (cb, opts) {
            clearTimeout(saveTimer); if (window.plusEnAttente) window.plusEnAttente('learning');
            window.syncWithServer('save_learning', { learning: S.learning }, function () { if (cb) cb(); }, opts);
        };
        if (window.enAttente) window.enAttente('learning', envoyer);
        saveTimer = setTimeout(function () { envoyer(); }, 1500);
    };
    // Fiches EDN (PDF) déposées sur le serveur : numéro d'item → nom de fichier ; index.html les préfère aux liens Drive
    window.LOCAL_FICHES = null;
    window.loadLocalFiches = function () {
        postApi({ action: 'fiche_index' }, function (res) {
            window.LOCAL_FICHES = (res && res.success && res.items) ? res.items : {};
            if (Object.keys(window.LOCAL_FICHES).length) window.renderContent();
        }, function () { window.LOCAL_FICHES = {}; });
    };
    window.initLearning = function () {
        window.loadLearningLocal();
        window.loadLocalFiches();
        window.syncWithServer('get_learning', {}, function (d) {
            // Un échec de lecture laisse learningPret à faux : on préfère ne rien enregistrer qu'écraser.
            if (!d || !d.success) {
                if (window.toast) window.toast('Historique QCM illisible : rien ne sera enregistré tant que le serveur n\'a pas répondu. Recharge la page.', { type: 'danger', duree: 8000 });
                return;
            }
            var localHadMore = S.learning.log.length;
            var changed = d.learning ? window.mergeLearning(d.learning) : false;
            learningPret = true;   // la ligne du serveur est connue : on peut désormais la remplacer sans rien perdre
            if (changed) window.saveLearning(true);
            // des entrées notées avant la réponse du serveur : on renvoie la fusion, jamais l'état nu
            if (localHadMore && (!d.learning || !d.learning.log || d.learning.log.length < S.learning.log.length)) window.saveLearning();
            window.reparerDecksRegroupes();
            // La maîtrise vient d'arriver, et elle ne sert pas qu'ici : la ligne de séance affiche le taux de
            // réussite de son item, et l'ordre de la journée met le moins bien réussi en tête. Or render() ne
            // redessine QUE l'onglet QCM — la page ouverte gardait donc l'ordre et les pastilles d'avant le
            // chargement du journal, c'est-à-dire ceux d'un historique vide.
            invalidateMastery();
            render();
            if (!surPage() && window.renderContent) window.renderContent();
        });
        // Onglet QCM ouvert avec une séance mise de côté : l'écran l'annonce (avant le premier dessin) puis la reprend.
        // Une séance d'annale se reprend sur Training, une séance d'item sur QCM : chacune à sa place.
        var sv = sessionSauvee();
        if (sv && ((S.activeTab === 'qcm' && !sv.annale) || (S.activeTab === 'training' && sv.annale))) {
            S.qcm.reprise = 'attente'; window.qcmRestaurerSession(function () { render(); });
        }
    };

    // ------------------------------------------------------------------ index et chargement des items
    window.loadQcmIndex = function (cb) {
        if (S.qcm.index) { if (cb) cb(S.qcm.index); return; }
        if (cb) S.qcm.indexWaiters.push(cb);
        if (S.qcm.indexLoading) return;
        S.qcm.indexLoading = true;
        var finish = function (items, err) {
            items = items || {};
            Object.keys(ITEM_ALIASES).forEach(function (from) {
                var to = ITEM_ALIASES[from], src = items[from];
                if (!src) return;
                var dst = items[to] || (items[to] = { file: null, titre: itemTitle(to), spec: src.spec, nb: 0, ped: 0, img: 0, types: {} });
                dst.nb += src.nb || 0; dst.ped += src.ped || 0; dst.img += src.img || 0;
                Object.keys(src.types || {}).forEach(function (k) { dst.types[k] = (dst.types[k] || 0) + src.types[k]; });
                (dst.extras = dst.extras || []).push({ n: from, file: src.file, titre: src.titre });
                delete items[from];
            });
            S.qcm.index = items;
            S.qcm.indexError = err || null;
            S.qcm.indexLoading = false;
            var w = S.qcm.indexWaiters; S.qcm.indexWaiters = [];
            w.forEach(function (f) { try { f(S.qcm.index); } catch (e) { } });
            render();
        };
        fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'qcm_index' }) })
            .then(function (r) { return r.json(); })
            .then(function (d) { if (d && d.success && d.items) { S.qcm.source = 'api'; return d.items; } throw new Error('no api'); })
            .catch(function () {
                return fetch('qcm/index.json').then(function (r) { if (!r.ok) throw new Error('no index'); return r.json(); }).then(function (d) { S.qcm.source = 'static'; return d.items || {}; });
            })
            .then(function (items) { finish(items, Object.keys(items).length ? null : 'Aucun QCM trouvé : dépose les fichiers JSON du scraper dans edn_data/qcm/ sur le serveur (voir DONNEES.md).'); })
            .catch(function () { finish({}, 'Index des QCM indisponible : le dossier edn_data/qcm/ du serveur est absent ou vide (voir DONNEES.md).'); });
    };
    // ------------------------------------------------------------------ corrections de QCM (enregistrées sur le serveur)
    // Certaines réponses du dépôt edn.fr sont fausses : depuis la correction d'une question, on peut changer les bonnes
    // réponses, retoucher le texte d'une proposition, ajouter des réponses acceptées (saisie libre) ou masquer la question.
    // Les corrections vivent dans <edn_data>/qcm_overrides/<item>.json et s'appliquent à chaque chargement.
    // QCM rédigés par l'IA pour le renforcement pédiatrie (<edn_data>/qcm_ai/<item>.json), fusionnés avec la banque edn.fr
    function fetchAiQuestions(n) {
        if (S.qcm.source === 'static') return Promise.resolve([]);
        return fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ action: 'qcm_ai_get', item: n }) })
            .then(function (r) { return r.json(); }).then(function (j) { return (j && j.success && Array.isArray(j.questions)) ? j.questions : []; }).catch(function () { return []; });
    }
    function fetchOverrides(n) {
        if (S.qcm.source === 'static') return Promise.resolve({});
        return fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ action: 'qcm_overrides_get', item: n }) })
            .then(function (r) { return r.json(); }).then(function (j) { return (j && j.success && j.overrides && !Array.isArray(j.overrides)) ? j.overrides : {}; }).catch(function () { return {}; });
    }
    function applyOverride(q, ov) {
        if (!q._orig) q._orig = { props: (q.propositions || []).map(function (p) { return { id: p.id, est_correcte: !!p.est_correcte, texte: p.texte, texte_html: p.texte_html }; }), accepted: (q.reponses_acceptees || []).slice() };
        // retour à l'original puis application
        (q.propositions || []).forEach(function (p) { var o = null; q._orig.props.some(function (x) { if (x.id === p.id) { o = x; return true; } return false; }); if (o) { p.est_correcte = o.est_correcte; p.texte = o.texte; p.texte_html = o.texte_html; } });
        q.reponses_acceptees = q._orig.accepted.slice();
        q._hidden = false; q._override = ov || null;
        if (!ov) return;
        (q.propositions || []).forEach(function (p) {
            var e = ov.props && ov.props[p.id]; if (!e) return;
            if (typeof e.est_correcte === 'boolean') p.est_correcte = e.est_correcte;
            if (e.texte) { p.texte = e.texte; p.texte_html = esc(e.texte); }
        });
        (ov.accepted_add || []).forEach(function (a) { if (q.reponses_acceptees.indexOf(a) < 0) q.reponses_acceptees.push(a); });
        if (ov.hidden) q._hidden = true;
    }
    function overrideFromForm(q) {
        var orig = q._orig || { props: (q.propositions || []).map(function (p) { return { id: p.id, est_correcte: !!p.est_correcte, texte: p.texte }; }), accepted: (q.reponses_acceptees || []).slice() };
        var ov = { props: {} }, any = false;
        (q.propositions || []).forEach(function (p) {
            var o = null; orig.props.some(function (x) { if (x.id === p.id) { o = x; return true; } return false; });
            var cb = document.getElementById('qcm-edit-correct-' + p.id), tx = document.getElementById('qcm-edit-text-' + p.id);
            var e = {};
            if (cb && o && !!cb.checked !== !!o.est_correcte) e.est_correcte = !!cb.checked;
            if (tx && o && tx.value.trim() && tx.value.trim() !== (o.texte || '').trim()) e.texte = tx.value.trim();
            if (Object.keys(e).length) { ov.props[p.id] = e; any = true; }
        });
        if (!any) delete ov.props;
        var acc = document.getElementById('qcm-edit-accepted');
        if (acc && acc.value.trim()) { var add = acc.value.split(';').map(function (x) { return x.trim(); }).filter(function (x) { return x && orig.accepted.indexOf(x) < 0; }); if (add.length) { ov.accepted_add = add; any = true; } }
        var hid = document.getElementById('qcm-edit-hidden'); if (hid && hid.checked) { ov.hidden = true; any = true; }
        var note = document.getElementById('qcm-edit-note'); if (note && note.value.trim()) { ov.note = note.value.trim(); }
        return any ? ov : null;
    }
    function saveOverride(n, q, ov, cb) {
        fetch('api.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ action: 'qcm_override_save', item: n, question: q.id, override: ov }) })
            .then(function (r) { return r.json(); })
            .then(function (j) { if (!j || !j.success) throw new Error(j && j.message || 'Enregistrement refusé'); cb(null, j.overrides || {}, j.portee || ''); })
            .catch(function (e) { cb(e.message); });
    }
    function rehideItem(n) {
        var d = S.qcm.items[n]; if (!d) return;
        d.questions = (d.questions || []).concat(d._hidden || []);
        prepareItem(n, d);
    }
    window.actions.qcmEditToggle = function () { var s = S.qcm.session; if (!s || !s.revealed) return; s.editing = !s.editing; s.editError = null; render(); };
    window.actions.qcmSaveOverride = function (reset) {
        var s = S.qcm.session, q = curQ(); if (!s || !q) return;
        var n = String(q._item || s.n);
        var ov = reset ? null : overrideFromForm(q);
        s.editBusy = true; render();
        saveOverride(n, q, ov, function (err, all, portee) {
            s.editBusy = false;
            if (err) { s.editError = err; render(); return; }
            var d = S.qcm.items[n]; if (d) d._ov = all;
            applyOverride(q, all[q.id] || null);
            // la question qu'on vient de répondre est re-notée avec la correction
            var r = s.results[s.results.length - 1];
            if (r && r.q === q) { var res = scoreQuestion(q, s.ans); r.score = res.score; r.detail = res; if (r.entry) { r.entry.s = res.score; r.entry.fixed = true; } window.saveLearning(); }
            if (d) rehideItem(n);
            s.editing = false; s.editError = null;
            var pour = portee === 'partagee' ? 'pour tout le monde' : 'pour toi';
            s.editMsg = q._hidden
                ? 'Question masquée ' + pour + ' : elle ne sera plus proposée.'
                : (ov ? 'Correction enregistrée ' + pour + ' : elle s\'applique à toutes les prochaines sessions.'
                      : 'Question rétablie dans sa version d\'origine.');
            render();
        });
    };
    window.actions.qcmUnhide = function (n) {
        n = String(n); var d = S.qcm.items[n]; if (!d || !(d._hidden || []).length) return;
        var nb = d._hidden.length;
        window.dialogue.confirmer({
            titre: 'Rétablir ' + nb + ' question' + (nb > 1 ? 's' : '') + ' masquée' + (nb > 1 ? 's' : '') + ' ?',
            message: 'Elles redeviennent proposables dans les séances de cet item, avec leurs corrections d\'origine.',
            ok: 'Rétablir'
        }).then(function (oui) {
            if (!oui) return;
            var pending = nb;
            d._hidden.forEach(function (q) {
                var ov = q._override ? JSON.parse(JSON.stringify(q._override)) : null; if (ov) { delete ov.hidden; if (!ov.props && !ov.accepted_add) ov = null; }
                saveOverride(n, q, ov, function (err, all) { if (!err) { d._ov = all; applyOverride(q, all[q.id] || null); } if (--pending === 0) { rehideItem(n); render(); } });
            });
        });
    };
    function prepareItem(n, d) {
        var notions = {};
        d._hidden = (d.questions || []).filter(function (q) { return q._hidden; });
        d.questions = (d.questions || []).filter(function (q) { return !q._hidden; });
        (d.questions || []).forEach(function (q, idx) {
            q._idx = idx;
            q._nk = [];
            (q.notions || []).forEach(function (x) {
                var k = nrm(x.intitule);
                if (!k) return;
                if (q._nk.indexOf(k) < 0) q._nk.push(k);
                var e = notions[k] || (notions[k] = { key: k, title: x.intitule, rang: x.rang || null, chap: x.chapitre || '', count: 0 });
                e.count++;
                if (!e.rang && x.rang) e.rang = x.rang;
            });
        });
        d._notions = Object.keys(notions).map(function (k) { return notions[k]; }).sort(function (a, b) { return (a.chap + a.title).localeCompare(b.chap + b.title, 'fr'); });
        S.qcm.items[n] = d;
        return d;
    }
    window.loadQcmItem = function (n, cb) {
        n = String(n);
        if (S.qcm.items[n]) { if (cb) cb(S.qcm.items[n]); return; }
        window.loadQcmIndex(function (index) {
            var ix = index[n] || { file: null, extras: [] };
            if (S.qcm.loading[n]) { if (cb) S.qcm.loading[n].push(cb); return; }
            S.qcm.loading[n] = cb ? [cb] : [];
            var sources = [];
            if (ix.file) sources.push({ n: n, ix: ix });
            (ix.extras || []).forEach(function (e) { sources.push({ n: e.n, ix: e, from: e.n }); });
            var aiP = Promise.all([fetchAiQuestions(n), fetchOverrides(n)]).then(function (pair) { pair[0].forEach(function (q) { q._item = n; if (pair[1] && pair[1][q.id]) applyOverride(q, pair[1][q.id]); }); return pair[0]; });
            Promise.all([aiP].concat(sources.map(function (src) {
                return Promise.all([
                    fetch(qcmFileUrl(src.n, src.ix), { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); }),
                    fetchOverrides(src.n)
                ]).then(function (pair) {
                    var d = pair[0]; d._ov = pair[1] || {};
                    (d.questions || []).forEach(function (q) { if (src.from) q._from = src.from; q._item = src.n; normaliserQuestion(q); if (d._ov[q.id]) applyOverride(q, d._ov[q.id]); });
                    return d;
                });
            })))
                .then(function (all) {
                    var aiQs = all[0], parts = all.slice(1);
                    if (!parts.length && !aiQs.length) { S.qcm.loadError[n] = 'Pas de fichier QCM pour cet item.'; var w0 = S.qcm.loading[n]; delete S.qcm.loading[n]; w0.forEach(function (f) { try { f(null); } catch (e) { } }); render(); return; }
                    var d = parts[0] || { item_numero: parseInt(n, 10), item_titre: itemTitle(n), questions: [] };
                    var seen = {}; d.questions = (d.questions || []).filter(function (q) { if (seen[q.id]) return false; seen[q.id] = 1; return true; });
                    parts.slice(1).forEach(function (extra) { (extra.questions || []).forEach(function (q) { if (!seen[q.id]) { seen[q.id] = 1; d.questions.push(q); } }); });
                    aiQs.forEach(function (q) { if (!seen[q.id]) { seen[q.id] = 1; d.questions.push(q); } });
                    prepareItem(n, d);
                    var w = S.qcm.loading[n]; delete S.qcm.loading[n];
                    w.forEach(function (f) { try { f(d); } catch (e) { console.error(e); } });
                    render();
                })
                .catch(function (e) {
                    S.qcm.loadError[n] = 'Chargement impossible (' + e.message + ')';
                    var w = S.qcm.loading[n]; delete S.qcm.loading[n];
                    w.forEach(function (f) { try { f(null); } catch (e2) { } });
                    render();
                });
        });
    };

    // ------------------------------------------------------------------ sous-parties (items scindés)
    function partsFor(n) { var p = S.subParts && S.subParts[String(n)]; return (p && p.length > 1) ? p : null; }
    function partSig(parts) { return parts.join('|'); }
    function partMap(n, kind) {
        var parts = partsFor(n); if (!parts) return null;
        var pm = S.learning.partMaps[String(n)];
        if (!pm || !pm[kind] || pm[kind].sig !== partSig(parts)) return null;
        return pm[kind].map;
    }
    function questionPart(q, map) {
        if (!map) return -1;
        var votes = {}, best = -1, bestN = 0;
        q._nk.forEach(function (k) { var p = map[k]; if (p === undefined || p === null || p < 0) return; votes[p] = (votes[p] || 0) + 1; });
        Object.keys(votes).forEach(function (p) { if (votes[p] > bestN) { bestN = votes[p]; best = parseInt(p, 10); } });
        return best;
    }
    // part : null (item entier), un numéro de sous-partie, ou une LISTE de sous-parties réunies le temps d'une
    // séance — les questions de chacune, les transversales une seule fois.
    function questionsForPart(d, n, part) {
        var qs = d.questions;
        if (S.qcm.pedia) qs = qs.filter(function (q) { return !!q.est_pediatrique; });
        if (part == null || part < 0) return qs;
        var map = partMap(n, 'notions');
        if (!map) return qs;
        if (Array.isArray(part)) return qs.filter(function (q) { var p = questionPart(q, map); return p === -1 || part.indexOf(p) >= 0; });
        return qs.filter(function (q) { var p = questionPart(q, map); return p === part || p === -1; });
    }
    // ---- Plusieurs sous-parties réunies le temps d'une séance ------------------------------------------------
    // Une séance de QCM ou de flashcards peut piocher dans plusieurs sous-parties d'un item scindé. Rien n'est
    // fusionné : chaque réponse est journalisée dans la sous-partie de sa question, chaque carte reste dans son
    // paquet et y garde ses échéances. La réunion ne dure que le temps de la séance.
    // Argument de portée d'une action : '' ou null (item entier), un numéro, ou une liste (data-args est du JSON).
    // Une liste réduite à une sous-partie redevient cette sous-partie ; les numéros hors découpage sont écartés.
    function lirePartie(part, n) {
        if (!Array.isArray(part)) return (part === '' || part == null) ? null : parseInt(part, 10);
        var nb = (partsFor(n) || []).length, vus = {};
        var liste = part.map(function (k) { return parseInt(k, 10); })
            .filter(function (k) { if (isNaN(k) || k < 0 || k >= nb || vus[k]) return false; vus[k] = 1; return true; })
            .sort(function (a, b) { return a - b; });
        return liste.length >= 2 ? liste : (liste.length ? liste[0] : null);
    }
    // Sous-partie d'une question répondue dans une séance réunie : celle de la carte des notions, ou aucune
    // (transversale, ou répartition pas encore faite) — elle compte alors pour chacune.
    function partieDeQuestion(n, q) {
        var p = questionPart(q, partMap(n, 'notions'));
        return p >= 0 ? p : null;
    }
    // Les paquets des sous-parties réunies, vus comme un seul le temps de la séance. src : carte → sous-partie,
    // pour noter et supprimer une carte dans SON paquet.
    function deckReuni(n, parts) {
        var cartes = [], src = {};
        parts.forEach(function (k) { var d = getDeck(n, k); if (d) (d.cards || []).forEach(function (c) { src[c.id] = k; cartes.push(c); }); });
        return cartes.length ? { cards: cartes, src: src } : null;
    }
    // Ouvrir une seule sous-partie (ou l'item entier) — depuis la journée, le bilan du soir, l'active recall —
    // met fin à une réunion restée cochée : sinon le retour à l'item rouvrirait l'ancienne réunion.
    function finReunion() { if (S.qcm.parts && S.qcm.parts.length >= 2) S.qcm.parts = null; }
    function pediaArg() { return S.qcm.pedia ? 'true' : ''; }
    window.actions.qcmMapParts = function (n, kind) {
        n = String(n);
        var parts = partsFor(n); if (!parts) return;
        var labels = [];
        if (kind === 'notions') {
            var d = S.qcm.items[n]; if (!d) return;
            d._notions.forEach(function (x) { labels.push({ id: x.key, text: x.title + (x.chap ? ' (' + x.chap + ')' : '') }); });
        } else {
            var r = S.qcm.recall; if (!r || r.n !== n || !r.all) return;
            r.all.forEach(function (sec, i) { labels.push({ id: 's' + i, text: sec.label + ' : ' + sec.text.slice(0, 160) }); });
        }
        if (!labels.length) return;
        if (!ia()) return;   // sans abonnement, pas de répartition IA : les QCM restent classés par chapitre
        S.qcm.busy = 'map'; S.qcm.notice = null; render();
        postApi({ action: 'ai_map_parts', itemNumber: n, itemTitle: itemTitle(n), parts: parts, labels: labels }, function (res) {
            S.qcm.busy = '';
            if (!res.success) { S.qcm.notice = { type: 'error', text: res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : (res.message || 'Échec de la répartition IA') }; render(); return; }
            var pm = S.learning.partMaps[n] || (S.learning.partMaps[n] = {});
            pm[kind] = { sig: partSig(parts), map: res.assignments || {}, updated: Date.now() };
            pm.updated = Date.now();
            window.saveLearning();
            S.qcm.notice = { type: 'ok', text: (kind === 'notions' ? 'QCM répartis entre les sous-parties' : 'Sections de la fiche réparties') + (res.cached ? ' (résultat en cache)' : '') + '.' };
            render();
        });
    };

    // ------------------------------------------------------------------ maîtrise (algorithme points forts / points faibles)
    // Chaque réponse (QCM, flashcard, active recall) est une observation score∈[0;1], pondérée par sa fraîcheur
    // (demi-vie 45 jours) et par sa source (QCM officiel > flashcard > auto-évaluation). Une notion est rattachée à
    // l'observation par son intitulé normalisé (les intitulés edn.fr des QCM ; les flashcards et sections de fiche
    // sont reliées aux notions par recouvrement lexical au moment de l'enregistrement).
    var masteryCache = null;
    function invalidateMastery() { masteryCache = null; }
    window.invalidateMastery = invalidateMastery;
    var SRC_W = { qcm: 1, flash: 0.7, recall: 0.6, recall_ai: 0.9 }; // recall_ai : évaluation par l'IA de ce que l'étudiant a écrit de mémoire
    window.computeMastery = function () {
        if (masteryCache) return masteryCache;
        var now = Date.now(), items = {};
        S.learning.log.forEach(function (e) {
            if (e.m === 'time' || typeof e.s !== 'number') return; // séances chronométrées : pas un score
            var age = Math.max(0, (now - e.t) / 86400000);
            var w = Math.pow(0.5, age / 45) * (SRC_W[e.m] || 0.5);
            var it = items[e.i] || (items[e.i] = { w: 0, ws: 0, n: 0, last: 0, notions: {}, qLast: {}, qCount: 0, byMode: {}, recent: [] });
            it.w += w; it.ws += w * e.s; it.n++; it.last = Math.max(it.last, e.t);
            it.byMode[e.m] = (it.byMode[e.m] || 0) + 1;
            if (e.m === 'qcm') { if (it.qLast[e.q] === undefined) it.qCount++; it.qLast[e.q] = e.s; it.recent.push(e.s); }
            (e.n || []).forEach(function (title, k) {
                var key = nrm(title); if (!key) return;
                var nn = it.notions[key] || (it.notions[key] = { key: key, title: title, rang: (e.nr && e.nr[k]) || null, w: 0, ws: 0, n: 0, last: 0, byMode: {} });
                nn.w += w; nn.ws += w * e.s; nn.n++; nn.last = Math.max(nn.last, e.t);
                nn.byMode[e.m] = (nn.byMode[e.m] || 0) + 1;
                if (!nn.rang && e.nr && e.nr[k]) nn.rang = e.nr[k];
            });
        });
        Object.keys(items).forEach(function (n) {
            var it = items[n];
            it.mastery = it.w > 0 ? it.ws / it.w : null;
            var rec = it.recent.slice(-6), before = it.recent.slice(0, -6);
            var avg = function (a) { return a.length ? a.reduce(function (x, y) { return x + y; }, 0) / a.length : null; };
            it.trend = (rec.length >= 3 && before.length >= 3) ? (avg(rec) - avg(before)) : null;
            Object.keys(it.notions).forEach(function (k) { var nn = it.notions[k]; nn.mastery = nn.w > 0 ? nn.ws / nn.w : null; });
        });
        masteryCache = items;
        return items;
    };
    function itemMastery(n) { return window.computeMastery()[String(n)] || null; }
    // Même calcul que computeMastery, pour UN item et UN périmètre : le renforcement pédiatrie ne compte que les
    // observations faites en pédiatrie (ou sur une question pédiatrique), une sous-partie ne compte ni la pédiatrie
    // ni les autres sous-parties. Une question de QCM est rattachée à sa sous-partie par la carte des notions
    // quand elle existe, sinon par la sous-partie ouverte au moment de la réponse.
    function masteryScoped(n, part, pedia) {
        n = String(n);
        var d = S.qcm.items[n], map = (!pedia && part != null && d) ? partMap(n, 'notions') : null, byId = {};
        if (map) d.questions.forEach(function (q) { byId[q.id] = q; });
        var now = Date.now(), it = { w: 0, ws: 0, n: 0, last: 0, notions: {}, byMode: {} };
        S.learning.log.forEach(function (e) {
            if (String(e.i) !== n || e.m === 'time' || typeof e.s !== 'number') return;
            if (pedia) { if (!e.ped) return; }
            else {
                if (e.ped) return;
                if (part != null) {
                    var q = (e.m === 'qcm' && map) ? byId[e.q] : null;
                    if (q) { var pq = questionPart(q, map); if (pq !== part && pq !== -1) return; }
                    else if (e.p != null && e.p !== part) return;
                }
            }
            var age = Math.max(0, (now - e.t) / 86400000), w = Math.pow(0.5, age / 45) * (SRC_W[e.m] || 0.5);
            it.w += w; it.ws += w * e.s; it.n++; it.last = Math.max(it.last, e.t);
            it.byMode[e.m] = (it.byMode[e.m] || 0) + 1;
            (e.n || []).forEach(function (title, k) {
                var key = nrm(title); if (!key) return;
                var nn = it.notions[key] || (it.notions[key] = { key: key, title: title, rang: (e.nr && e.nr[k]) || null, w: 0, ws: 0, n: 0, last: 0, byMode: {} });
                nn.w += w; nn.ws += w * e.s; nn.n++; nn.last = Math.max(nn.last, e.t);
                nn.byMode[e.m] = (nn.byMode[e.m] || 0) + 1;
                if (!nn.rang && e.nr && e.nr[k]) nn.rang = e.nr[k];
            });
        });
        it.mastery = it.w > 0 ? it.ws / it.w : null;
        Object.keys(it.notions).forEach(function (k) { var nn = it.notions[k]; nn.mastery = nn.w > 0 ? nn.ws / nn.w : null; });
        return it.n ? it : null;
    }
    // scope : { part, pedia } — sans scope, ou item entier (part null, pas de pédiatrie), tout compte.
    function notionStats(n, scope) {
        var pedia = !!(scope && scope.pedia), part = (scope && scope.part != null) ? scope.part : null;
        var cantonne = pedia || part != null;
        // toutes les notions de l'item (fichier QCM chargé) enrichies de la maîtrise ; sinon uniquement celles du journal
        var M = cantonne ? masteryScoped(n, part, pedia) : itemMastery(n), d = S.qcm.items[String(n)], out = [], seen = {};
        var liste = d ? d._notions : [];
        // renforcement pédiatrie : seules les notions portées par des questions pédiatriques existent
        if (d && pedia) { var pedKeys = {}; d.questions.forEach(function (q) { if (q.est_pediatrique) (q._nk || []).forEach(function (k) { pedKeys[k] = 1; }); }); liste = liste.filter(function (x) { return pedKeys[x.key]; }); }
        if (d) liste.forEach(function (x) {
            var m = M && M.notions[x.key];
            out.push({ key: x.key, title: x.title, rang: x.rang, chap: x.chap, count: x.count, mastery: m ? m.mastery : null, n: m ? m.n : 0, last: m ? m.last : 0, byMode: m ? m.byMode : {} });
            seen[x.key] = 1;
        });
        if (M) Object.keys(M.notions).forEach(function (k) {
            if (seen[k]) return;
            var m = M.notions[k];
            out.push({ key: k, title: m.title, rang: m.rang, chap: '', count: 0, mastery: m.mastery, n: m.n, last: m.last, byMode: m.byMode, extra: true });
        });
        return out;
    }
    function weakestNotions(n, limit, scope) {
        return notionStats(n, scope).filter(function (x) { return x.n > 0; }).sort(function (a, b) { return (a.mastery - b.mastery) || (b.n - a.n); }).slice(0, limit || 10);
    }
    // notions QCM correspondant à un libellé (section de fiche, carte) : recouvrement lexical du titre, ou tous les
    // mots significatifs de la notion présents dans le texte de la section (libellés génériques comme « À savoir absolument »)
    function matchNotionTitles(n, label, text) {
        var d = S.qcm.items[String(n)]; if (!d) return [];
        var out = d._notions.filter(function (x) { return overlap(x.title, label) >= 0.6; });
        if (text) {
            var tt = {}; tokens(text).forEach(function (t) { tt[t] = 1; });
            d._notions.forEach(function (x) {
                if (out.indexOf(x) >= 0) return;
                var nt = tokens(x.title);
                if (nt.length && nt.every(function (t) { return tt[t]; })) out.push(x);
            });
        }
        return out.slice(0, 8).map(function (x) { return x.title; });
    }
    function itemNeverSeen(n) {
        n = String(n);
        if (itemMastery(n)) return false;
        return !(S.tasks || []).some(function (t) { return String(t.baseItemId || t.itemId) === n && t.status === 'done'; });
    }
    // lacunes repérées par l'IA en active recall (60 derniers jours, sans doublon), utilisées par les flashcards et le mini-cours
    // ------------------------------------------------------------------ notions « rang C » (hors programme R2C)
    // Le programme ne connaît que les rangs A et B : classer une notion « rang C » veut dire « ce n'est pas à savoir ».
    // Une section ainsi marquée sort de l'active recall, ses scores sont retirés du journal (elle ne pèse plus sur la
    // maîtrise) et ses lacunes sont supprimées, donc ni les flashcards ni le mini-cours ne la ciblent.
    window.isRangC = function (n, label) {
        var m = S.learning.rangC && S.learning.rangC[String(n)];
        var e = m && m[nrm(label)];
        return !!(e && !e.off);
    };
    window.setRangC = function (n, label, on, part) {
        n = String(n); var key = nrm(label); if (!key) return;
        var m = S.learning.rangC[n] = S.learning.rangC[n] || {};
        m[key] = { label: label, t: Date.now(), p: part == null ? null : part, off: !on };
        if (on) {
            // ce qui a été mesuré sur une notion hors programme ne doit plus compter
            var q = 'sec:' + key;
            S.learning.log = S.learning.log.filter(function (e) { return !(String(e.i) === n && e.q === q && (e.m === 'recall' || e.m === 'recall_ai')); });
            var g = S.learning.gaps[n];
            if (g) S.learning.gaps[n] = g.filter(function (x) { return nrm(x.sec || x.point || '') !== key; });
        }
        invalidateMastery(); window.saveLearning();
    };
    window.actions.recallToggleRangC = function (idx) {
        var r = S.qcm.recall; if (!r || !r.all) return;
        var sec = r.all[idx]; if (!sec) return;
        var on = !window.isRangC(r.n, sec.label);
        window.setRangC(r.n, sec.label, on, r.part);
        if (on) {
            // la section quitte la séance : on retire sa réponse et on reste au même endroit dans la liste
            r.results = r.results.filter(function (x) { return x.sec !== sec; });
            if (r.idx > 0 && r.idx >= recallList(r).length) r.idx = recallList(r).length;
            r.revealed = false; r.notes = '';
        }
        window.recallSaveDraft(r);
        S.qcm.notice = { type: 'ok', text: on ? '« ' + sec.label +' » classé rang C : retiré de l\'active recall, de ta maîtrise et des points à retravailler.' : '« ' + sec.label + ' » remis au programme.' };
        render();
    };
    // Périmètre d'une observation (QCM, carte, recall, lacune) : le renforcement pédiatrie ne voit que ce qui a été
    // fait en pédiatrie ; une sous-partie ne voit ni la pédiatrie ni les autres sous-parties ; l'item entier voit tout.
    // Plusieurs sous-parties réunies : ce qui appartient à l'une d'elles, plus ce qui n'appartient à aucune.
    function dansPerimetre(e, part, pedia) {
        if (pedia) return !!e.ped;
        if (e.ped) return part == null;
        if (Array.isArray(part)) return e.p == null || part.indexOf(e.p) >= 0;
        return part == null || e.p == null || e.p === part;
    }
    function itemGaps(n, part, pedia) {
        if (pedia === undefined) pedia = S.qcm.pedia;
        var list = (S.learning.gaps && S.learning.gaps[String(n)]) || [], cutoff = Date.now() - 60 * 86400000, seen = {}, out = [];
        list.slice().reverse().forEach(function (g) {
            if (g.t < cutoff) return;
            if (!dansPerimetre(g, part, pedia)) return;
            var k = nrm(g.titre); if (!k || seen[k]) return; seen[k] = 1;
            out.push(g);
        });
        // les erreurs (quelque chose de faux a été écrit) passent devant les simples oublis
        out.sort(function (a, b) { return (b.type === 'erreur' ? 1 : 0) - (a.type === 'erreur' ? 1 : 0); });
        return out;
    }
    // y a-t-il du nouveau (erreur, lacune, QCM raté, recall faible) sur cet item depuis un instant t ?
    function newWeakSince(n, part, t) {
        n = String(n);
        var c = { gaps: 0, errors: 0, failed: 0 };
        (S.learning.gaps[n] || []).forEach(function (g) { if (g.t > t && dansPerimetre(g, part, S.qcm.pedia)) { c.gaps++; if (g.type === 'erreur') c.errors++; } });
        S.learning.log.forEach(function (e) { if (e.i === n && e.t > t && e.s < 1 && (e.m === 'qcm' || e.m === 'recall_ai') && dansPerimetre(e, part, S.qcm.pedia)) c.failed++; });
        c.total = c.gaps + c.failed;
        return c;
    }
    function logEntry(e) {
        e.t = e.t || Date.now();
        S.learning.log.push(e);
        if (S.learning.log.length > 20000) S.learning.log = S.learning.log.slice(-20000);
        window.saveLearning();
        return e;
    }

    // ------------------------------------------------------------------ correction des différents types de question
    function parseCoords(str) { return String(str || '').split(',').map(function (p) { var xy = p.split(':'); return [parseFloat(xy[0]), parseFloat(xy[1])]; }).filter(function (p) { return !isNaN(p[0]) && !isNaN(p[1]); }); }
    function pointInPoly(x, y, poly) {
        var inside = false;
        for (var i = 0, j = poly.length - 1; i < poly.length; j = i++) {
            var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
            var inter = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (inter) inside = !inside;
        }
        return inside;
    }
    function correctPolys(q) {
        var polys = [];
        (q.zones || []).forEach(function (z) { (z.zones_correctes || []).forEach(function (zc) { var pts = (zc.points && zc.points.length > 2) ? zc.points : parseCoords(zc.coordonnees); if (pts.length > 2) polys.push(pts); }); });
        if (!polys.length) (q.propositions || []).forEach(function (p) { if (p.est_correcte && p.coordonnees) { var pts = parseCoords(p.coordonnees); if (pts.length > 2) polys.push(pts); } });
        return polys;
    }
    function isMany(q) { return /^MANY/.test(q.methode_reponse || ''); }
    // Question à nombre de réponses défini (QRP, « Quelles sont les 3… ») : on coche exactement le nombre annoncé,
    // et la note est la part de bonnes réponses parmi ce nombre — pas le barème aux discordances des QRM.
    function isDefined(q) { return /^MANY_DEFINED/.test(q.methode_reponse || ''); }
    function nbAttendu(q) {
        var n = parseInt(q.nb_reponses_attendues, 10);
        if (n > 0) return n;
        return (q.propositions || []).filter(function (x) { return x.est_correcte; }).length || 1;
    }
    function isText(q) { return q.methode_reponse === 'MATCH' || q.saisie_libre; }
    function isArea(q) { return q.methode_reponse === 'MATCHING_AREA' || q.zones_cliquables; }
    // EDN.fr note chaque proposition d'un de quatre statuts : WIN (juste), FAIL ou LOSE (fausse), MANDATORY
    // (indispensable : une bonne réponse, qu'on doit cocher — l'oublier compte comme une discordance, pas plus) et
    // ELIMINATORY (inacceptable : une fausse réponse, notée comme les autres — le mot est seulement affiché à côté). Les exports ne marquaient « est_correcte » que sur WIN : une indispensable passait pour fausse.
    // Le statut est resté dans chaque fichier ; on le relit au chargement — rien à retélécharger, rien à réécrire.
    function normaliserQuestion(q) {
        if (!q || q._statuts) return q;
        q._statuts = true;
        (q.propositions || []).forEach(function (p) {
            var st = String(p.statut || '').toUpperCase();
            if (st === 'MANDATORY') { p.est_correcte = true; p.indispensable = true; }
            else if (st === 'ELIMINATORY') { p.est_correcte = false; p.inacceptable = true; }
        });
        return q;
    }
    window.qcmNormaliserQuestion = normaliserQuestion;
    function acceptedAnswers(q) {
        var acc = (q.reponses_acceptees || []).slice();
        (q.propositions || []).forEach(function (p) { if (p.est_correcte && p.texte && acc.indexOf(p.texte) < 0) acc.push(p.texte); });
        return acc;
    }
    function scoreQuestion(q, ans) {
        var t = q.methode_reponse;
        if (isArea(q)) {
            if (!ans || ans.x == null) return { score: 0 };
            var polys = correctPolys(q);
            return { score: polys.some(function (poly) { return pointInPoly(ans.x, ans.y, poly); }) ? 1 : 0, uncertain: !polys.length };
        }
        if (isText(q)) {
            var a = nrm(ans);
            if (!a) return { score: 0 };
            var num = parseFloat(String(ans).replace(',', '.'));
            var ok = acceptedAnswers(q).some(function (x) {
                if (nrm(x) === a) return true;
                var nx = parseFloat(String(x).replace(',', '.'));
                return !isNaN(num) && !isNaN(nx) && /^[\d\s.,]+$/.test(String(x).trim()) && Math.abs(num - nx) < 1e-9;
            });
            return { score: ok ? 1 : 0 };
        }
        if (t === 'TCS' || t === 'ONE') {
            var p = null; (q.propositions || []).forEach(function (x) { if (x.id === ans) p = x; });
            if (!p) return { score: 0 };
            if (t === 'TCS') { var c = p.coefficient; if (c == null) c = p.est_correcte ? 1 : 0; return { score: Math.max(0, Math.min(1, c)) }; }
            return { score: p.est_correcte ? 1 : 0 };
        }
        // QRP (nombre défini) : une part par bonne réponse, sur le nombre attendu. Cocher plus que ce nombre est
        // impossible à l'écran ; si c'est arrivé quand même (ancienne réponse, séance reprise), la note est nulle.
        // Indispensable et inacceptable ne changent pas le barème : l'une est une bonne réponse, l'autre une fausse,
        // et le barème ordinaire s'en charge. Leur mot n'est qu'affiché à la correction.
        if (isDefined(q)) {
            var choisis = Object.keys(ans || {}).filter(function (k) { return ans[k]; });
            var attendu = nbAttendu(q);
            if (choisis.length > attendu) return { score: 0, justes: 0, attendues: attendu, trop: true };
            var justes = (q.propositions || []).filter(function (x) { return x.est_correcte && ans[x.id]; }).length;
            return { score: Math.round((justes / attendu) * 1000) / 1000, justes: justes, attendues: attendu };
        }
        // réponses multiples : barème EDN (0 discordance = 1 ; 1 = 0,5 ; 2 = 0,2 ; ≥ 3 = 0)
        var set = ans || {}, disc = 0;
        (q.propositions || []).forEach(function (x) { if (!!set[x.id] !== !!x.est_correcte) disc++; });
        return { score: disc === 0 ? 1 : disc === 1 ? 0.5 : disc === 2 ? 0.2 : 0, disc: disc };
    }
    // ------------------------------------------------------------------ sessions de QCM
    function buildQuestionSet(n, opts) {
        var d = S.qcm.items[n]; if (!d) return [];
        var qs = questionsForPart(d, n, opts.part).slice();
        var M = itemMastery(n);
        if (opts.mode === 'errors') qs = qs.filter(function (q) { return M && M.qLast[q.id] !== undefined && M.qLast[q.id] < 1; });
        if (opts.mode === 'notion') qs = qs.filter(function (q) { return q._nk.indexOf(opts.notionKey) >= 0; });
        if (opts.mode === 'single') qs = qs.filter(function (q) { return q.id === opts.qid; });
        if (opts.mode === 'adaptive') {
            // priorité : jamais vues > ratées > notions faibles ; les questions réussies récemment passent en dernier
            var now = Date.now(), lastSeen = {};
            S.learning.log.forEach(function (e) { if (e.m === 'qcm' && e.i === n) lastSeen[e.q] = Math.max(lastSeen[e.q] || 0, e.t); });
            var weighted = qs.map(function (q) {
                var w;
                if (!M || M.qLast[q.id] === undefined) w = 3;
                else w = 0.3 + (1 - M.qLast[q.id]) * 2.5;
                var weakBonus = 0;
                q._nk.forEach(function (k) { var nn = M && M.notions[k]; if (nn && nn.mastery != null) weakBonus = Math.max(weakBonus, 1 - nn.mastery); });
                w += weakBonus;
                if (lastSeen[q.id] && now - lastSeen[q.id] < 2 * 86400000) w *= 0.15;
                return { q: q, w: w * (0.6 + Math.random() * 0.8) };
            });
            weighted.sort(function (a, b) { return b.w - a.w; });
            qs = weighted.slice(0, opts.count || 10).map(function (x) { return x.q; });
            shuffle(qs);
        } else if (opts.mode === 'errors' || opts.mode === 'notion') {
            shuffle(qs);
            if (opts.count) qs = qs.slice(0, opts.count);
        }
        return qs;
    }
    // part : '' (item entier), un numéro de sous-partie, ou une liste de sous-parties réunies le temps de la séance.
    window.actions.qcmStartSession = function (n, mode, part, extra) {
        n = String(n);
        var opts = { mode: mode, part: lirePartie(part, n), count: 10 };
        var reunies = Array.isArray(opts.part) ? opts.part : null;
        if (mode === 'notion') opts.notionKey = decodeURIComponent(extra || '');
        if (mode === 'single') opts.qid = extra;
        if (mode === 'adaptive' && extra) opts.count = parseInt(extra, 10) || 10;
        window.loadQcmItem(n, function (d) {
            if (!d) return;
            var list = buildQuestionSet(n, opts);
            if (!list.length) {
                if (S.qcm.soir) { window.soirSauter('aucune question'); return; }
                S.qcm.notice = { type: 'warn', text: 'Aucune question ne correspond à cette sélection.' }; render(); return;
            }
            S.qcm.current = n; S.qcm.part = reunies ? null : opts.part;
            if (reunies) S.qcm.parts = reunies; else finReunion();   // de retour sur l'item, la même réunion est encore cochée
            S.qcm.session = { n: n, part: S.qcm.part, parts: reunies || undefined, mode: mode, list: list, idx: 0, ans: null, revealed: false, results: [], started: Date.now() };
            // Séance réunie : le chronomètre part sur la première des sous-parties qui a une séance du jour
            // (autoStartTaskTimer ne fait rien dès qu'un chronomètre tourne).
            if (window.autoStartTaskTimer) { var pn = partsFor(n); (reunies || [opts.part]).forEach(function (k) { window.autoStartTaskTimer(n, (k != null && pn) ? pn[k] : '', false); }); }
            S.qcm.view = 'session'; S.qcm.notice = null;
            if (S.activeTab !== 'qcm') { S.activeTab = 'qcm'; window.renderHeader(); }
            window.renderContent();
            window.scrollTo(0, 0);
        });
    };
    function curQ() { var s = S.qcm.session; return s ? s.list[s.idx] : null; }
    // Cocher une réponse ne redessine que les propositions (ou le pointage) et le bouton Valider : un re-rendu
    // complet rejouait l'animation d'apparition de la carte et faisait tressauter l'encart. Le dessin appartient
    // désormais au module de la page, qui expose window.qcmMajReponse ; sans lui, on retombe sur le rendu complet.
    function refreshAnswerUi() { if (window.qcmMajReponse) { window.qcmMajReponse(); sessionSave(); return; } render(); }
    window.refreshAnswerUi = refreshAnswerUi;
    window.actions.qcmPick = function (id) { var s = S.qcm.session; if (!s || s.revealed) return; s.ans = id; refreshAnswerUi(); };
    window.actions.qcmToggle = function (id) {
        var s = S.qcm.session; if (!s || s.revealed) return;
        s.ans = s.ans || {};
        if (s.ans[id]) delete s.ans[id];
        else {
            // QRP : le nombre annoncé est une limite, comme le jour J — une case de plus est refusée.
            var q = curQ();
            if (q && isDefined(q) && Object.keys(s.ans).filter(function (k) { return s.ans[k]; }).length >= nbAttendu(q)) { refreshAnswerUi(); return; }
            s.ans[id] = true;
        }
        refreshAnswerUi();
    };
    // Appelées par data-input-action / data-enter : l'exécuteur passe l'élément et l'évènement à la suite des
    // arguments. Les deux formes d'appel (valeur nue de l'ancien onclick, élément de la délégation) sont admises.
    window.actions.qcmText = function (v) { var s = S.qcm.session; if (!s || s.revealed) return; s.ans = (v && v.value !== undefined) ? v.value : v; };
    window.actions.qcmTextKey = function (ev) { if (ev && ev.key === 'Enter') { ev.preventDefault(); } window.actions.qcmValidate(); };
    window.actions.qcmAreaClick = function (imgId, el, ev) {
        var s = S.qcm.session; if (!s || s.revealed || !ev) return;
        var img = document.getElementById(imgId); if (!img || !img.naturalWidth) return;
        var rect = img.getBoundingClientRect();
        var x = (ev.clientX - rect.left) * img.naturalWidth / rect.width;
        var y = (ev.clientY - rect.top) * img.naturalHeight / rect.height;
        s.ans = { x: Math.round(x), y: Math.round(y), nw: img.naturalWidth, nh: img.naturalHeight };
        refreshAnswerUi();
    };
    window.actions.qcmValidate = function () {
        var s = S.qcm.session, q = curQ(); if (!s || !q || s.revealed) return;
        if (isText(q)) { var inp = document.getElementById('qcm-text-input'); if (inp) s.ans = inp.value; }
        var res = scoreQuestion(q, s.ans);
        s.revealed = true;
        var given = isText(q) ? String(s.ans || '').slice(0, 200) : (isArea(q) ? null : (isMany(q) ? Object.keys(s.ans || {}).filter(function (k) { return s.ans[k]; }) : s.ans));
        // Annale : la question porte son vrai item (celui de sa notion) — c'est lui qui gagne en maîtrise. Sans
        // item connu, on n'écrit rien au journal plutôt que d'y inventer un item fantôme.
        var itemJournal = s.annale ? (q.item_numero != null ? String(q.item_numero) : null) : s.n;
        var entry = !itemJournal ? null : logEntry({ m: 'qcm', i: itemJournal, src: s.annale ? 'annale' : undefined, ex: s.annale ? s.annale.id : undefined, q: q.id, a: given, s: res.score, n: (q.notions || []).map(function (x) { return x.intitule; }), nr: (q.notions || []).map(function (x) { return x.rang || null; }), p: s.parts ? partieDeQuestion(s.n, q) : s.part, ty: q.methode_reponse, ped: (S.qcm.pedia || q.est_pediatrique) ? 1 : undefined, ai: q._ai ? 1 : undefined });
        // La réponse donnée est gardée avec son résultat : une épreuve corrigée à la fin la remontre question par question.
        s.results.push({ q: q, score: res.score, entry: entry, detail: res, ans: s.ans == null ? null : JSON.parse(JSON.stringify(s.ans)) });
        // Épreuve (annales, masterclass) : comme le jour J, pas de correction avant la fin. La réponse est notée et
        // journalisée tout de suite — la maîtrise ne dépend pas du moment où l'on voit le corrigé — puis on enchaîne.
        if (s.differe) {
            s.revealed = false; s.ans = null;
            if (s.idx + 1 >= s.list.length) s.finished = true; else s.idx++;
            render(); window.scrollTo(0, 0); return;
        }
        // La correction s'ouvre sous la question sans reconstruire la page : le module remplace le seul nœud
        // #qcm-correction (et l'en-tête de séance, pour la jauge et le compteur).
        if (window.qcmMajCorrection) { window.qcmMajCorrection(); sessionSave(); return; }
        render();
        var el = document.getElementById('qcm-correction'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    // « Je compte ma réponse comme juste » : saisie libre ou zone quand la correction automatique doute
    window.actions.qcmSelfCorrect = function () {
        var s = S.qcm.session; if (!s || !s.revealed) return;
        var r = s.results[s.results.length - 1]; if (!r) return;
        r.score = 1; if (r.entry) { r.entry.s = 1; r.entry.self = true; }
        window.saveLearning(); render();
    };
    window.actions.qcmNext = function () {
        var s = S.qcm.session; if (!s) return;
        if (s.idx + 1 >= s.list.length) {
            s.finished = true;
            if (S.qcm.soir && !s.compteeSoir) { s.compteeSoir = true; window.soirCompter(s.results); }
            render(); window.scrollTo(0, 0); return;
        }
        s.idx++; s.ans = null; s.revealed = false; s.editing = false; s.editMsg = null; render(); window.scrollTo(0, 0);
    };
    window.actions.qcmQuit = function () {
        var annale = S.qcm.session && S.qcm.session.annale;
        S.qcm.session = null; sessionClear();
        S.qcm.view = annale ? 'annaleSujet' : 'item';   // une annale ramène à son sujet, pas à un item
        render();
    };
    window.actions.qcmRestartErrors = function () {
        var s = S.qcm.session; if (!s) return;
        var wrong = s.results.filter(function (r) { return r.score < 1; }).map(function (r) { return r.q; });
        if (!wrong.length) return;
        S.qcm.session = { n: s.n, annale: s.annale, differe: s.differe, part: s.part, parts: s.parts, mode: s.annale ? 'annale' : 'retry', list: s.annale ? wrong.slice() : shuffle(wrong.slice()), idx: 0, ans: null, revealed: false, results: [], started: Date.now() };
        render(); window.scrollTo(0, 0);
    };
    // Ordre d'affichage des propositions : mélangé tant qu'on répond, pour ne pas mémoriser la POSITION des bonnes
    // réponses plutôt que leur contenu ; remis dans l'ordre officiel edn.fr dès que la correction s'affiche, afin de
    // retrouver la question telle qu'elle sera posée. Le mélange est tiré une fois par question et par session : les
    // propositions ne bougent pas pendant qu'on coche.
    function propsInOrder(q) { return (q.propositions || []).slice().sort(function (a, b) { return (a.ordre || 0) - (b.ordre || 0); }); }
    function propsForDisplay(q, s) {
        var list = propsInOrder(q);
        // Un TCS est une ÉCHELLE ordonnée (de -2 à +2) : la mélanger la rendrait illisible. On ne mélange que les
        // propositions d'un QCM, pour qu'on ne retienne pas la position des bonnes réponses.
        if (!s || s.revealed || list.length < 2 || q.methode_reponse === 'TCS') return list;
        s.shuffle = s.shuffle || {};
        if (!s.shuffle[q.id]) s.shuffle[q.id] = shuffle(list.map(function (p) { return p.id; }));
        var byId = {}; list.forEach(function (p) { byId[p.id] = p; });
        var out = [];
        s.shuffle[q.id].forEach(function (id) { if (byId[id]) { out.push(byId[id]); delete byId[id]; } });
        list.forEach(function (p) { if (byId[p.id]) out.push(p); }); // proposition ajoutée depuis (correction manuelle)
        return out;
    }
    // ------------------------------------------------------------------ vue item
    window.actions.qcmOpenItem = function (n, part, notionEnc, pedia) {
        if (window.dictStopIfOn) window.dictStopIfOn(); // le micro ne doit jamais rester ouvert en quittant la séance
        n = String(n);
        S.qcm.current = n;
        // une liste : on revient sur l'item avec les mêmes sous-parties réunies (retour de séance ou de révision)
        var portee = lirePartie(part, n);
        S.qcm.part = Array.isArray(portee) ? null : portee; S.qcm.parts = Array.isArray(portee) ? portee : null;
        S.qcm.pedia = !!pedia && pedia !== '' && pedia !== 'false';
        S.qcm.filterNotion = notionEnc ? decodeURIComponent(notionEnc) : null;
        S.qcm.filterMode = 'all'; S.qcm.showAllQuestions = !!notionEnc;
        S.qcm.session = null; S.qcm.view = 'item'; S.qcm.notice = null;
        window.loadQcmItem(n);
        // Depuis une autre page (séance du jour, calendrier) : un vrai changement d'onglet, adresse et titre compris,
        // pour que Précédent ramène à la page de départ et qu'un rechargement reste sur le QCM.
        if (S.activeTab !== 'qcm' && window.actions.switchTab) window.actions.switchTab('qcm');
        else { S.activeTab = 'qcm'; window.renderHeader(); window.renderContent(); window.scrollTo(0, 0); }
    };
    window.actions.qcmOpenPart = function (n, encName) {
        var parts = partsFor(n), name = decodeURIComponent(encName || '');
        var idx = parts ? parts.indexOf(name) : -1;
        window.actions.qcmOpenItem(n, idx >= 0 ? idx : '', '');
    };
    window.actions.qcmSetPart = function (part) { S.qcm.part = (part === '' || part == null) ? null : parseInt(part, 10); S.qcm.parts = null; S.qcm.filterNotion = null; render(); };
    // « Plusieurs sous-parties » : les choix deviennent des cases à cocher. On part de la sous-partie ouverte,
    // pour que le premier clic en ajoute une seconde au lieu de tout recommencer.
    window.actions.qcmReunirParties = function (on) {
        if (on) S.qcm.parts = S.qcm.part != null ? [S.qcm.part] : [];
        else { S.qcm.part = (S.qcm.parts && S.qcm.parts.length === 1) ? S.qcm.parts[0] : S.qcm.part; S.qcm.parts = null; }
        S.qcm.filterNotion = null; render();
    };
    // Cocher / décocher une sous-partie. Une seule cochée : c'est cette sous-partie, comme un choix simple (active
    // recall et mini-cours compris) ; aucune : l'item entier ; deux ou plus : QCM et flashcards réunis.
    window.actions.qcmCocherPartie = function (k) {
        k = parseInt(k, 10); if (isNaN(k)) return;
        var l = (S.qcm.parts || []).slice(), i = l.indexOf(k);
        if (i >= 0) l.splice(i, 1); else l.push(k);
        l.sort(function (a, b) { return a - b; });
        S.qcm.parts = l; S.qcm.part = l.length === 1 ? l[0] : null; S.qcm.filterNotion = null; render();
    };
    window.actions.qcmFilterNotion = function (enc) { S.qcm.filterNotion = enc ? decodeURIComponent(enc) : null; S.qcm.showAllQuestions = true; render(); };
    window.actions.qcmFilterMode = function (m) { S.qcm.filterMode = m; S.qcm.showAllQuestions = true; render(); };
    window.actions.qcmBackToList = function () { if (window.dictStopIfOn) window.dictStopIfOn(); S.qcm.view = (S.qcm.current && !itemMeta(S.qcm.current)) ? 'quiz' : 'list'; S.qcm.current = null; S.qcm.session = null; S.qcm.pedia = false; S.qcm.parts = null; render(); };
    window.actions.qcmView = function (v) {
        S.qcm.view = v; S.qcm.notice = null;
        if (v === 'annales' && !S.qcm.annales) { window.actions.annalesCharger(); return; }
        render();
    };

    // ------------------------------------------------------------------ annales EDN.fr (privées, administrateur)
    // Les sujets de la page Annales d'EDN.fr, récupérés sur sa machine par edn_annales_scraper.py (dépôt qcm) et
    // déposés dans edn_data/annales/. Le serveur ne les sert qu'au compte administrateur. Leurs questions ont la
    // forme de celles des items : le même moteur de séance les joue et les note, et chaque réponse compte pour le
    // vrai item de la question.
    window.actions.annalesCharger = function () {
        S.qcm.annales = { chargement: true, index: null, erreur: null, type: null };
        render();
        postApi({ action: 'annales_index' }, function (d) {
            var a = S.qcm.annales || (S.qcm.annales = {});
            a.chargement = false;
            if (!d || !d.success) { a.erreur = (d && d.message) || 'Index des annales illisible.'; render(); return; }
            a.index = d.index;
            // Par défaut tous les types, classés par matière : c'est ainsi qu'on révise une spécialité.
            a.type = a.type || '*'; a.classer = a.classer || 'matiere';
            render();
        }, function (e) { var a = S.qcm.annales || {}; a.chargement = false; a.erreur = e.message; render(); });
    };
    window.actions.annalesType = function (t) { if (!S.qcm.annales) return; S.qcm.annales.type = t; S.qcm.annales.matiere = ''; S.qcm.annales.nbDate = 0; render(); if (window.qcmTrainingRefocus) window.qcmTrainingRefocus('annalesType', t); };
    function annalesSujetCharger(type, id, cb) {
        postApi({ action: 'annales_sujet', type: type, id: id }, function (d) {
            if (!d || !d.success || !d.sujet) { cb(null, (d && d.message) || 'Sujet introuvable.'); return; }
            (d.sujet.contenus || []).forEach(function (b) {
                (b.dossiers || []).forEach(function (dd) { (dd.questions || []).forEach(normaliserQuestion); });
                (b.questions_isolees || []).forEach(normaliserQuestion);
            });
            cb(d.sujet);
        }, function (e) { cb(null, e.message); });
    }
    window.actions.annalesSujet = function (type, id) {
        S.qcm.annaleSujet = { chargement: true, type: type, id: id, sujet: null };
        S.qcm.view = 'annaleSujet'; S.qcm.notice = null; render(); window.scrollTo(0, 0);
        annalesSujetCharger(type, id, function (sujet, err) {
            if (!S.qcm.annaleSujet || S.qcm.annaleSujet.id !== id) return;
            S.qcm.annaleSujet.chargement = false;
            if (!sujet) { S.qcm.annaleSujet.erreur = err; render(); return; }
            S.qcm.annaleSujet.sujet = sujet; render();
        });
    };
    // Les questions d'un sujet dans l'ordre de l'épreuve, chacune portant son dossier (le cas clinique à relire
    // avant de répondre). `dossier` restreint à un seul dossier ; sinon, tout le sujet, questions isolées comprises.
    function annalesQuestions(sujet, dossier) {
        var list = [];
        (sujet.contenus || []).forEach(function (b, ib) {
            (b.dossiers || []).forEach(function (d, id) {
                if (dossier != null && dossier !== ib + ':' + id) return;
                var ctx = { titre: d.titre, type: d.type, enonce_html: d.enonce_html, images: d.images || [], contenus_enonce: d.contenus_enonce || [], rang: id + 1, total: (b.dossiers || []).length };
                (d.questions || []).forEach(function (q, k) { list.push(Object.assign({}, q, { _dossier: ctx, _rangDossier: k + 1, _nbDossier: d.questions.length })); });
            });
            if (dossier == null) (b.questions_isolees || []).forEach(function (q) { list.push(Object.assign({}, q, { _dossier: null })); });
        });
        return list;
    }
    window.actions.annalesLancer = function (dossier) {
        var a = S.qcm.annaleSujet; if (!a || !a.sujet) return;
        var list = annalesQuestions(a.sujet, dossier === '' || dossier == null ? null : String(dossier));
        if (!list.length) { S.qcm.notice = { type: 'warn', text: 'Ce sujet ne contient aucune question jouable.' }; render(); return; }
        // Toutes les annales se passent en épreuve : on répond à tout, la correction vient à la fin (differe).
        S.qcm.session = { n: 'annale', annale: { id: a.sujet.id, type: a.type, titre: a.sujet.titre, dossier: dossier == null ? null : String(dossier), video: a.sujet.video || null },
            part: null, mode: 'annale', differe: true, list: list, idx: 0, ans: null, revealed: false, results: [], started: Date.now() };
        S.qcm.view = 'session'; S.qcm.notice = null;
        render(); window.scrollTo(0, 0);
    };
    window.actions.annalesRetour = function () { S.qcm.view = 'annales'; S.qcm.notice = null; render(); window.scrollTo(0, 0); };
    function annalesReprendre(sv, cb) {
        annalesSujetCharger(sv.annale.type, sv.annale.id, function (sujet) {
            S.qcm.reprise = null;
            if (!sujet) { sessionClear(); if (cb) cb(false); return; }
            var byId = {}; annalesQuestions(sujet, sv.annale.dossier == null ? null : sv.annale.dossier).forEach(function (q) { byId[q.id] = q; });
            var list = sv.ids.map(function (id) { return byId[id]; }).filter(Boolean);
            if (!list.length) { sessionClear(); if (cb) cb(false); return; }
            S.qcm.annaleSujet = { type: sv.annale.type, id: sujet.id, sujet: sujet };
            S.qcm.session = { n: 'annale', annale: { id: sujet.id, type: sv.annale.type, titre: sujet.titre, dossier: sv.annale.dossier, video: sujet.video || null },
                part: null, mode: 'annale', differe: true, list: list, idx: Math.min(sv.idx || 0, list.length - 1), ans: sv.ans == null ? null : sv.ans,
                revealed: !!sv.revealed, started: sv.started || Date.now(),
                results: (sv.results || []).map(function (r) { return { q: byId[r.id], score: r.score, entry: null, detail: r.detail, ans: r.ans == null ? null : r.ans }; }).filter(function (r) { return r.q; }) };
            S.qcm.view = 'session'; S.qcm.notice = { type: 'info', text: 'Sujet repris là où tu l\'avais laissé.' };
            if (cb) cb(true);
        });
    }
    // ouverture depuis une tâche du planning (item entier, sous-partie scindée ou renforcement pédiatrie)
    window.actions.openQcmForTask = function (taskId) {
        var t = null; (S.tasks || []).some(function (x) { if (x.id === taskId) { t = x; return true; } return false; });
        if (!t) return;
        var base = String(t.baseItemId || t.itemId);
        var part = null;
        if (t.itemId !== base && String(t.itemId).indexOf('_p') > 0) {
            var m = /_p\d+(\d)$/.exec(String(t.itemId));
            var parts = partsFor(base);
            if (parts) {
                var pName = (t.titre || '').replace(/^.*\[(.*)\]\s*$/, '$1');
                var idx = parts.indexOf(pName);
                if (idx < 0 && m) idx = parseInt(m[1], 10);
                if (idx >= 0 && idx < parts.length) part = idx;
            }
        }
        window.actions.qcmOpenItem(base, part == null ? '' : part, '', window.isPediaTask ? window.isPediaTask(t) : !!t.isDouble);
    };

    // QCM pédiatriques rédigés par l'IA (fiche EDN + collège de pédiatrie), enregistrés sur le serveur puis fusionnés avec la banque
    window.actions.qcmGenPedia = function (n) {
        if (!ia()) { refusIA(); return; }
        n = String(n); if (S.qcm.busy) return;
        S.qcm.busy = 'qcmgen'; S.qcm.notice = null;
        var LOT = 4, voulu = 10, lots = Math.ceil(voulu / LOT), ajoutes = [], meta = null;
        S.qcm.aiProgress = { fait: 0, total: lots }; render();
        var d = S.qcm.items[n];
        var weak = weakestNotions(n, 20, { part: null, pedia: true }).filter(function (x) { return x.mastery < 0.7; }).slice(0, 10).map(function (x) { return { title: x.title }; });
        var enonces = function () {
            var cur = S.qcm.items[n];
            var base = cur ? cur.questions.filter(function (q) { return q.est_pediatrique; }).map(function (q) { return (q.enonce || stripHtml(q.enonce_html) || '').slice(0, 200); }) : [];
            return base.concat(ajoutes.map(function (q) { return (q.enonce || '').slice(0, 200); }));
        };
        var finir = function (avertissement) {
            S.qcm.busy = ''; S.qcm.aiProgress = null;
            var nb = ajoutes.length;
            if (!nb) { S.qcm.notice = { type: 'error', text: avertissement || "L'IA n'a produit aucun QCM exploitable." }; render(); return; }
            S.qcm.notice = avertissement
                ? { type: 'warn', text: nb + ' QCM pédiatrique' + (nb > 1 ? 's' : '') + ' ajouté' + (nb > 1 ? 's' : '') + ', puis interruption : ' + avertissement + ' Relance pour en obtenir davantage.' }
                : { type: 'ok', text: nb + ' QCM pédiatrique' + (nb > 1 ? 's' : '') + ' ajouté' + (nb > 1 ? 's' : '') + ' (d\'après ' + ((meta && meta.source === 'pdf') ? 'la fiche EDN' : 'le programme') + ((meta && meta.college && meta.college.length) ? ' + le collège ' + collegeLabel(meta.college) : '') + '), enregistré' + (nb > 1 ? 's' : '') + ' sur le serveur.' };
            render();
        };
        // lots courts : une requête longue est coupée par le serveur web avant que l'IA ait fini
        var etape = function (k) {
            if (k >= lots || ajoutes.length >= voulu) { finir(null); return; }
            postApi({ action: 'ai_qcm_pedia', itemNumber: n, itemTitle: itemTitle(n), count: Math.min(LOT, voulu - ajoutes.length), matieres: itemMatieres(n), existing: enonces(), notionTitles: d ? d._notions.map(function (x) { return x.title; }) : [], weakNotions: weak }, function (res) {
                if (!res.success) {
                    // Clé manquante : le serveur nomme le fournisseur de cette fonction (Anthropic ou Mammouth) ; le texte en dur n'est qu'un repli.
                    var msg = res.message || (res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : 'Échec de la génération');
                    finir(ajoutes.length ? msg : msg); return;
                }
                meta = meta || res;
                var cur = S.qcm.items[n] || { item_numero: parseInt(n, 10), item_titre: itemTitle(n), questions: [], _hidden: [] };
                var vu = {}; cur.questions.concat(cur._hidden || []).forEach(function (q) { vu[q.id] = 1; });
                (res.added || []).forEach(function (q) { if (!vu[q.id]) { q._item = n; cur.questions.push(q); ajoutes.push(q); } });
                prepareItem(n, cur); delete S.qcm.loadError[n];
                S.qcm.aiProgress = { fait: k + 1, total: lots }; render();
                if (!(res.added || []).length) { finir(ajoutes.length ? null : (res.message || null)); return; } // plus rien de neuf à écrire
                etape(k + 1);
            }, function (e) { finir(e.message); });
        };
        etape(0);
    };
    // ---------------------------------------------------------------- « Extraire en PDF » : le livre des QCM
    // Le livre est fabriqué par le serveur (api.php?action=qcm_livre) et s'ouvre dans un onglet, prêt pour
    // « Enregistrer en PDF » de l'impression. Avant d'ouvrir, on montre ce que pèse la sélection : la banque
    // entière fait des milliers de questions, et l'impression d'un tel document met un navigateur à genoux.
    function livreParCollege() {
        var idx = S.qcm.index || {}, out = {};
        Object.keys(idx).forEach(function (n) {
            var e = idx[n]; if (!e || e.lca || !e.nb) return;
            var col = String(e.spec || '').split(' · ')[0].trim() || 'Sans collège';
            var c = out[col] || (out[col] = { nom: col, items: 0, q: 0, ped: 0 });
            c.items++; c.q += e.nb || 0; c.ped += e.ped || 0;
        });
        return Object.keys(out).sort(function (a, b) { return a.localeCompare(b, 'fr'); }).map(function (k) { return out[k]; });
    }
    window.actions.livreOuvrirChoix = function () {
        var cols = livreParCollege();
        S.qcm.livre = { colleges: cols.map(function (c) { return c.nom; }), ped: true, densite: 'compact' };
        S.modalConfig = { type: 'livre-qcm' };
        window.renderModal();
    };
    window.actions.livreBasculerCollege = function (nom) {
        var L = S.qcm.livre; if (!L) return;
        var i = L.colleges.indexOf(nom);
        if (i >= 0) L.colleges.splice(i, 1); else L.colleges.push(nom);
        window.renderModal();
    };
    window.actions.livreTousColleges = function (tous) {
        var L = S.qcm.livre; if (!L) return;
        L.colleges = tous ? livreParCollege().map(function (c) { return c.nom; }) : [];
        window.renderModal();
    };
    window.actions.livrePed = function (v) { if (S.qcm.livre) { S.qcm.livre.ped = (v && typeof v.checked === 'boolean') ? v.checked : !!v; window.renderModal(); } };
    window.actions.livreDensite = function (v) { if (S.qcm.livre) { S.qcm.livre.densite = v; window.renderModal(); } };
    window.actions.livreImprimer = function () {
        var L = S.qcm.livre; if (!L || !L.colleges.length) return;
        var u = 'api.php?action=qcm_livre&mode=qcm&ped=' + (L.ped ? '1' : '0')
            + '&densite=' + (L.densite === 'confort' ? 'confort' : 'compact')
            + '&colleges=' + encodeURIComponent(L.colleges.join(','));
        S.modalConfig = null; window.renderModal();
        window.open(u, '_blank');
    };

    // ------------------------------------------------------------------ vue liste des items
    // Fouille du registre : ces quatre actions sont branchées par data-input-action / data-change-action, qui leur
    // passent l'élément ; elles acceptent encore la valeur nue. Le dessin des lignes appartient au module.
    function valeurDe(v) { return (v && v.value !== undefined) ? v.value : v; }
    function relisterQcm() { if (window.renderQcmListe) window.renderQcmListe(); }
    window.actions.qcmSearch = function (v) { S.qcm.search = valeurDe(v); relisterQcm(); };
    window.actions.qcmSort = function (v) { S.qcm.sort = valeurDe(v); relisterQcm(); };
    window.actions.qcmSpec = function (v) { S.qcm.spec = valeurDe(v); relisterQcm(); };
    window.actions.qcmOnlyWithQcm = function (v) { S.qcm.onlyWithQcm = (v && typeof v.checked === 'boolean') ? v.checked : !!v; relisterQcm(); };
    function listRows() {
        var q = nrm(S.qcm.search), Mall = window.computeMastery(), idx = S.qcm.index || {};
        var rows = (window.ednsItems || []).map(function (it) {
            var n = String(it.id), ix = idx[n], M = Mall[n];
            return { n: n, it: it, ix: ix, M: M, mastery: M ? M.mastery : null, coverage: (ix && ix.nb && M) ? M.qCount / ix.nb : (M ? null : 0) };
        }).filter(function (r) {
            if (S.qcm.onlyWithQcm && !r.ix) return false;
            if (S.qcm.spec !== 'all' && r.it.matiere !== S.qcm.spec && r.it.collegesSecondaires.indexOf(S.qcm.spec) < 0) return false;
            if (!q) return true;
            return nrm(r.it.titre).indexOf(q) >= 0 || r.n.indexOf(q) >= 0 || nrm(r.it.matiere).indexOf(q) >= 0;
        });
        var s = S.qcm.sort;
        rows.sort(function (a, b) {
            if (s === 'weak') { var ma = a.mastery == null ? 2 : a.mastery, mb = b.mastery == null ? 2 : b.mastery; return ma - mb || parseInt(a.n, 10) - parseInt(b.n, 10); }
            if (s === 'coverage') { var ca = a.ix ? (a.coverage || 0) : 2, cb = b.ix ? (b.coverage || 0) : 2; return ca - cb || parseInt(a.n, 10) - parseInt(b.n, 10); }
            if (s === 'recent') return ((b.M && b.M.last) || 0) - ((a.M && a.M.last) || 0);
            if (s === 'nb') return ((b.ix && b.ix.nb) || 0) - ((a.ix && a.ix.nb) || 0);
            if (s === 'spec') return a.it.matiere.localeCompare(b.it.matiere, 'fr') || parseInt(a.n, 10) - parseInt(b.n, 10);
            return parseInt(a.n, 10) - parseInt(b.n, 10);
        });
        return rows;
    }
    // ------------------------------------------------------------------ vue statistiques globales
    window.actions.qcmStatsSpec = function (v) { S.qcm.statsSpec = (v && v.value !== undefined) ? v.value : v; render(); };
    // ------------------------------------------------------------------ flashcards recto/verso (IA + répétition espacée)
    function deckKeyFor(n, part, pedia) { return ((part == null || part < 0) ? String(n) : String(n) + '#' + part) + (pedia ? '#ped' : ''); }
    function deckKey(n, part) { return deckKeyFor(n, part, S.qcm.pedia); }
    function getDeck(n, part) { return S.learning.decks[deckKey(n, part)] || null; }
    function dueCards(deck) { var now = Date.now(); return deck.cards.filter(function (c) { return !c.due || c.due <= now; }).sort(function (a, b) { return (a.due || 0) - (b.due || 0); }); }
    // Cartes venues d'un lot (Batches) : elles rejoignent le paquet de l'item entier, prêtes à réviser tout de suite.
    // Les doublons de recto sont écartés, un lot pouvant recouvrir un paquet déjà commencé.
    // Empreinte d'une question : même règle que le serveur (ednEmpreinteCarte d'api.php) — minuscules, sans
    // accents ni ponctuation, mots vides ôtés, mots triés. Deux formulations du même fait se reconnaissent.
    var CARTE_VIDES = { le:1, la:1, les:1, un:1, une:1, des:1, du:1, de:1, d:1, l:1, et:1, ou:1, a:1, au:1, aux:1, en:1,
        quel:1, quelle:1, quels:1, quelles:1, est:1, sont:1, ce:1, que:1, qui:1, pour:1, chez:1, sur:1, dans:1, donne:1, cite:1, citer:1 };
    function empreinteCarte(txt) {
        var t = String(txt || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ');
        // Un nombre est gardé quelle que soit sa longueur : c'est souvent lui qui distingue deux cartes.
        return t.split(' ').filter(function (m) { return (m.length > 2 || /^\d+$/.test(m)) && !CARTE_VIDES[m]; }).sort().join(' ');
    }
    // Deux questions testent le même fait quand leurs empreintes partagent l'essentiel de leurs mots : l'égalité
    // stricte laissait passer « … chez le nourrisson : quelle valeur ? » face à « … chez le nourrisson ? ».
    function carteDoublon(emp, vues) {
        if (!emp) return false;
        if (vues[emp]) return true;
        var a = emp.split(' ');
        return Object.keys(vues).some(function (autre) {
            var b = autre.split(' '), min = Math.min(a.length, b.length);
            if (min < 3) return false;
            var dans = {}; b.forEach(function (m) { dans[m] = 1; });
            var communs = 0; a.forEach(function (m) { if (dans[m]) communs++; });
            return communs / min >= 0.8;
        });
    }
    // Tout ce que l'étudiant possède déjà sur cet item, TOUS decks confondus (item entier et sous-parties) : c'est
    // la liste que l'IA doit éviter. Sans elle, chaque relance repartait des notions les plus saillantes de la
    // fiche et refabriquait les mêmes cartes.
    window.cartesDejaVues = function (n, part) {
        var rectos = [], notions = {}, vus = {};
        Object.keys(S.learning.decks || {}).forEach(function (k) {
            var d = S.learning.decks[k];
            if (!d || String(d.n) !== String(n)) return;
            // le deck pédiatrie ne se compare qu'aux decks pédiatrie : une carte adulte sur une notion n'interdit
            // pas la carte pédiatrique sur la même notion (c'est justement l'angle de l'enfant qu'on veut)
            if ((k.indexOf('#ped') >= 0) !== !!S.qcm.pedia) return;
            (d.cards || []).forEach(function (c) {
                var e = empreinteCarte(c.recto);
                if (e && !vus[e]) { vus[e] = 1; rectos.push(String(c.recto || '')); }
                var nt = String(c.notion || '').trim();
                if (nt) notions[nt] = (notions[nt] || 0) + 1;
            });
        });
        var liste = Object.keys(notions).sort(function (a, b) { return notions[b] - notions[a]; })
            .map(function (t) { return t + ' (' + notions[t] + ')'; });
        // les plus récentes d'abord : ce sont celles que le modèle risque le plus de refaire
        return { rectos: rectos.slice(-80).reverse(), notions: liste.slice(0, 120), empreintes: vus, part: part };
    };
    window.addAiCardsToDeck = function (n, cards, subPartTitle, pedia) {
        if (!cards || !cards.length) return 0;
        // Les cartes d'un lot rejoignent le deck de leur périmètre : sous-partie (retrouvée par son nom) ou
        // renforcement pédiatrie — plus jamais le deck de l'item entier par défaut.
        var parts = partsFor(n), part = (subPartTitle && parts) ? parts.indexOf(subPartTitle) : -1;
        var key = deckKeyFor(n, part < 0 ? null : part, !!pedia);
        var deck = S.learning.decks[key] || (S.learning.decks[key] = { n: String(n), part: part < 0 ? null : part, created: Date.now(), cards: [] });
        var vus = {};
        deck.cards.forEach(function (c) { vus[String(c.recto || '').trim().toLowerCase()] = true; });
        var now = Date.now(), ajoutees = 0;
        cards.forEach(function (c, i) {
            var cle = String(c.recto || '').trim().toLowerCase();
            if (!cle || vus[cle]) return;
            vus[cle] = true; ajoutees++;
            deck.cards.push({ id: 'c' + now.toString(36) + i.toString(36) + Math.random().toString(36).slice(2, 6), recto: c.recto, verso: c.verso, notion: c.notion || '', section: c.section || '', rang: c.rang || 'A', explication: c.explication || '', origine: c.origine || '', created: now, due: now, ivl: 0, reps: 0, lapses: 0 });
        });
        if (ajoutees) { deck.updated = now; window.saveLearning(); }
        return ajoutees;
    };
    // ---- Regroupement d'un item scindé : ses paquets de sous-parties rejoignent celui de l'item entier ----------
    // Les paquets sont rangés par NUMÉRO de sous-partie (« 23#0 », « 23#1 ») : une fois le découpage retiré, ces
    // paquets n'étaient plus atteignables et les cartes déjà créées semblaient perdues. On les verse donc dans le
    // paquet de l'item entier, avec tout leur historique de révision (échéance, intervalle, reprises, oublis), et
    // chaque carte garde d'où elle vient — c'est ce qui permet de défaire le regroupement sans rien perdre.
    // Un doublon exact de recto n'est pas recopié deux fois : on garde la carte la plus révisée.
    window.fusionnerDecksSousParties = function (n, parts) {
        if (!S.learning || !S.learning.decks || !parts || parts.length < 2) return 0;
        var deplacees = 0;
        [false, true].forEach(function (pedia) {
            var cibleCle = deckKeyFor(n, null, pedia), source = [];
            for (var i = 0; i < parts.length; i++) {
                var d = S.learning.decks[deckKeyFor(n, i, pedia)];
                if (d && (d.cards || []).length) source.push({ i: i, cle: deckKeyFor(n, i, pedia), deck: d });
            }
            if (!source.length) return;
            var cible = S.learning.decks[cibleCle] || (S.learning.decks[cibleCle] = { n: String(n), part: null, created: Date.now(), cards: [] });
            var vus = {};
            cible.cards.forEach(function (c) { vus[String(c.recto || '').trim().toLowerCase()] = c; });
            source.forEach(function (src) {
                src.deck.cards.forEach(function (c) {
                    var cle = String(c.recto || '').trim().toLowerCase(), ancienne = cle ? vus[cle] : null;
                    if (ancienne) { if ((c.reps || 0) > (ancienne.reps || 0)) { ancienne.reps = c.reps; ancienne.ivl = c.ivl; ancienne.due = c.due; ancienne.lapses = c.lapses; ancienne.last = c.last; ancienne.lastScore = c.lastScore; } return; }
                    c.origPart = src.i; c.origTitre = String(parts[src.i] || '');
                    if (cle) vus[cle] = c;
                    cible.cards.push(c); deplacees++;
                });
                delete S.learning.decks[src.cle];
            });
            cible.updated = Date.now();
        });
        return deplacees;
    };
    // Découpage rétabli : chaque carte retourne dans le paquet de la sous-partie d'où elle vient. Les cartes
    // créées pendant le regroupement (sans origine) restent sur l'item entier : elles ont été faites pour lui.
    window.separerDecksSousParties = function (n, parts) {
        if (!S.learning || !S.learning.decks || !parts || parts.length < 2) return 0;
        var rendues = 0;
        [false, true].forEach(function (pedia) {
            var cible = S.learning.decks[deckKeyFor(n, null, pedia)];
            if (!cible || !(cible.cards || []).length) return;
            var restent = [];
            cible.cards.forEach(function (c) {
                var i = c.origPart;
                // L'origine ne vaut que si la sous-partie existe encore et porte toujours le même nom : un
                // découpage refait entre-temps ne doit pas renvoyer la carte dans une sous-partie sans rapport.
                if (i == null || i < 0 || i >= parts.length || (c.origTitre && c.origTitre !== String(parts[i]))) { delete c.origPart; delete c.origTitre; restent.push(c); return; }
                var cle = deckKeyFor(n, i, pedia);
                var d = S.learning.decks[cle] || (S.learning.decks[cle] = { n: String(n), part: i, created: Date.now(), cards: [] });
                delete c.origPart; delete c.origTitre;
                d.cards.push(c); d.updated = Date.now(); rendues++;
            });
            cible.cards = restent;
            if (!cible.cards.length) delete S.learning.decks[deckKeyFor(n, null, pedia)];
            else cible.updated = Date.now();
        });
        return rendues;
    };
    // Items regroupés AVANT que ce versement n'existe : leurs paquets de sous-parties sont restés de côté, sans
    // moyen de les ouvrir depuis la carte de l'item entier. On les verse au chargement — sans effet une fois fait.
    window.reparerDecksRegroupes = function () {
        if (!S.learning || !S.learning.decks) return 0;
        var A = S.subPartsArchive || {}, total = 0;
        Object.keys(A).forEach(function (id) { total += window.fusionnerDecksSousParties(id, A[id] || []); });
        if (total) { window.saveLearning(); if (window.renderContent) window.renderContent(); }
        return total;
    };
    // part : '' (item entier), un numéro de sous-partie, ou une liste de sous-parties dont les paquets sont
    // réunis le temps de la révision (f.parts, f.src : carte → sous-partie).
    window.actions.flashOpen = function (n, part, reviewAll) {
        n = String(n);
        var portee = lirePartie(part, n), reunies = Array.isArray(portee) ? portee : null;
        S.qcm.current = n; S.qcm.part = reunies ? null : portee;
        if (reunies) S.qcm.parts = reunies; else finReunion();
        S.qcm.view = 'flash'; S.qcm.notice = null; S.activeTab = 'qcm';
        var deck = reunies ? deckReuni(n, reunies) : getDeck(n, S.qcm.part);
        var queue = deck ? (reviewAll ? shuffle(deck.cards.slice()) : dueCards(deck)) : [];
        S.qcm.flash = { n: n, part: S.qcm.part, parts: reunies || undefined, src: (reunies && deck) ? deck.src : undefined,
            queue: queue, idx: 0, flipped: false, results: [], all: !!reviewAll, count: 15, mode: itemNeverSeen(n) ? 'discovery' : 'weak' };
        window.loadQcmItem(n, function () { });
        window.renderHeader(); window.renderContent(); window.scrollTo(0, 0);
    };
    window.actions.flashSetMode = function (m) { if (S.qcm.flash) { S.qcm.flash.mode = m; render(); } };
    window.actions.flashSetCount = function (c) { if (S.qcm.flash) S.qcm.flash.count = parseInt((c && c.value !== undefined) ? c.value : c, 10) || 15; };
    window.actions.flashRate = function (kind) {
        var f = S.qcm.flash; if (!f || !f.queue[f.idx]) return;
        var card = f.queue[f.idx], now = Date.now(), score;
        var ivl = card.ivl || 0;
        if (kind === 'again') { score = 0; ivl = 0; card.lapses = (card.lapses || 0) + 1; card.due = now + 10 * 60000; }
        else if (kind === 'hard') { score = 0.5; ivl = Math.max(1, ivl * 1.2); card.due = now + ivl * 86400000; }
        else if (kind === 'good') { score = 1; ivl = ivl < 1 ? 1 : ivl * 2.5; card.due = now + ivl * 86400000; }
        else { score = 1; ivl = ivl < 1 ? 3 : ivl * 4; card.due = now + ivl * 86400000; }
        card.ivl = Math.round(ivl * 10) / 10; card.reps = (card.reps || 0) + 1; card.last = now; card.lastScore = score;
        var partCarte = f.parts ? (f.src || {})[card.id] : f.part;   // révision réunie : le paquet et la sous-partie de la carte
        var deck = getDeck(f.n, partCarte); if (deck) deck.updated = now;
        var notions = [card.notion].concat(matchNotionTitles(f.n, card.notion).filter(function (t) { return nrm(t) !== nrm(card.notion); }));
        logEntry({ m: 'flash', i: f.n, q: 'card:' + card.id, s: score, n: notions, nr: notions.map(function (t, i) { return i === 0 ? (card.rang || null) : null; }), p: partCarte, ped: S.qcm.pedia ? 1 : undefined });
        f.results.push({ card: card, score: score });
        if (kind === 'again' && !f.all) f.queue.push(card); // repasse en fin de file
        f.idx++; f.flipped = false;
        // Paquet épuisé pendant un bilan du soir : les cartes de cet item entrent dans le compte général.
        if (f.idx >= f.queue.length && S.qcm.soir && !f.compteeSoir) { f.compteeSoir = true; window.soirCompter(f.results); }
        render();
    };
    window.actions.flashDeleteCard = function (id) {
        var f = S.qcm.flash, deck = f && getDeck(f.n, f.parts ? (f.src || {})[id] : f.part); if (!deck) return;
        deck.cards = deck.cards.filter(function (c) { return c.id !== id; });
        f.queue = f.queue.filter(function (c) { return c.id !== id; });
        if (f.idx >= f.queue.length) f.idx = f.queue.length;
        deck.updated = Date.now(); window.saveLearning(); render();
    };
    window.actions.flashDeleteDeck = function () {
        // révision réunie : il n'y a pas « un » paquet à supprimer, chaque sous-partie garde le sien
        var f = S.qcm.flash, deck = f && !f.parts && getDeck(f.n, f.part); if (!f || !deck) return;
        var nb = (deck.cards || []).length;
        window.dialogue.confirmer({
            titre: 'Supprimer les ' + nb + ' cartes de ce paquet ?',
            message: 'Les révisions déjà faites restent comptées dans ta maîtrise ; seules les cartes disparaissent. C\'est définitif.',
            ok: 'Supprimer le paquet', danger: true
        }).then(function (oui) {
            if (!oui) return;
            delete S.learning.decks[deckKey(f.n, f.part)];
            f.queue = []; f.idx = 0; f.results = [];
            window.saveLearning(); render();
        });
    };
    function chronoText(n, cb) {
        // texte de la fiche ultra-récap, si disponible (sinon chaîne vide) — jamais bloquant
        var cache = S.qcm.chronoCache = S.qcm.chronoCache || {};
        if (cache[n] !== undefined) { cb(cache[n]); return; }
        postApi({ action: 'chrono_fiche', item: n }, function (res) {
            cache[n] = (res && res.success && res.html) ? stripHtml(res.html).slice(0, 14000) : '';
            cb(cache[n]);
        }, function () { cache[n] = ''; cb(''); });
    }
    // QCM ratés récemment sur l'item (ou la sous-partie), détaillés pour l'IA : propositions vraies/fausses, ce qui a été
    // coché, réponse libre, correction, nombre d'échecs et dernier score. Partagé par les flashcards et le mini-cours.
    function failedQuestionsDetail(n, part, d, map, max) {
        var failed = []; if (!d) return failed;
        var byId = {}; d.questions.forEach(function (q) { byId[q.id] = q; });
        var seen = {}, failCount = {};
        S.learning.log.forEach(function (e) { if (e.m === 'qcm' && e.i === n && e.s < 1) failCount[e.q] = (failCount[e.q] || 0) + 1; });
        S.learning.log.slice().reverse().forEach(function (e) {
            if (e.m !== 'qcm' || e.i !== n || e.s >= 1 || seen[e.q] || failed.length >= max) return;
            var q = byId[e.q]; if (!q) return;
            if (S.qcm.pedia ? !q.est_pediatrique : (q.est_pediatrique && part != null)) return;
            if (part != null && map) { var p = questionPart(q, map); if (p !== part && p !== -1) return; }
            seen[e.q] = 1;
            var given = e.a, checked = {};
            if (Array.isArray(given)) given.forEach(function (id) { checked[id] = 1; }); else if (typeof given === 'string' && !isText(q)) checked[given] = 1;
            failed.push({
                enonce: (q.enonce || stripHtml(q.enonce_html)).slice(0, 700),
                propositions: isText(q) || isArea(q) ? [] : (q.propositions || []).slice().sort(function (a, b) { return (a.ordre || 0) - (b.ordre || 0); }).map(function (p) { return { texte: (p.texte || stripHtml(p.texte_html) || '').slice(0, 220), correcte: !!p.est_correcte, cochee: !!checked[p.id] }; }),
                reponse: isText(q) && typeof given === 'string' ? given : '',
                correction: ((q.correction || stripHtml(q.correction_html) || '') + (isText(q) ? ' Réponse(s) acceptée(s) : ' + acceptedAnswers(q).join(' ; ') : '')).slice(0, 900),
                fails: failCount[e.q] || 1, last: e.s
            });
        });
        return failed;
    }
    // Flashcards qui résistent : dernière note « Oublié » ou « Difficile », ou au moins deux oublis ; les plus récentes d'abord.
    function weakFlashcards(n, part, max) {
        var out = [];
        Object.keys(S.learning.decks).forEach(function (k) {
            var deck = S.learning.decks[k]; if (!deck || String(deck.n) !== String(n)) return;
            if ((k.indexOf('#ped') >= 0) !== !!S.qcm.pedia) return;
            if (!S.qcm.pedia && part != null && deck.part != null && deck.part !== part) return;
            if (part != null && deck.part != null && deck.part !== part) return;
            (deck.cards || []).forEach(function (c) {
                if (!c.reps) return;
                var weak = (c.lastScore != null && c.lastScore < 1) || (c.lapses || 0) >= 2;
                if (weak) out.push({ recto: String(c.recto || '').slice(0, 300), verso: String(c.verso || '').slice(0, 300), notion: c.notion || '', explication: (c.explication || '').slice(0, 300), lapses: c.lapses || 0, last: c.lastScore == null ? null : c.lastScore, t: c.last || 0 });
            });
        });
        out.sort(function (a, b) { return (a.last == null ? 2 : a.last) - (b.last == null ? 2 : b.last) || b.lapses - a.lapses || b.t - a.t; });
        return out.slice(0, max || 10).map(function (c) { delete c.t; return c; });
    }
    function itemMatieres(n) { var meta = itemMeta(n); return [specOf(n)].concat(meta && meta.collegesSecondaires ? meta.collegesSecondaires : []).filter(Boolean); }
    function collegeLabel(list) { return list.map(function (c) { return String(c.college).replace(/\.pdf$/i, '').replace(/_/g, ' ') + (c.pages ? ' (p. ' + c.pages[0] + '-' + c.pages[1] + ')' : ''); }).join(', '); }
    window.actions.flashGenerate = function () {
        if (!ia()) { refusIA(); return; }
        // révision réunie : une carte appartient au paquet d'UNE sous-partie, on la crée depuis celle-ci
        var f = S.qcm.flash; if (!f || f.parts || S.qcm.busy) return;
        var n = f.n, part = f.part, parts = partsFor(n);
        var subPartTitle = (part != null && parts) ? parts[part] : '';
        var mode = f.mode, count = f.count || 15;
        S.qcm.busy = 'flash'; S.qcm.notice = null; render();
        window.loadQcmItem(n, function (d) {
            window.loadFicheStructure(function () {
                var outline = '';
                var fs = window.FICHE_STRUCTURE && window.FICHE_STRUCTURE[n];
                if (fs && fs.tree) {
                    var nodes = fs.tree;
                    if (subPartTitle) {
                        // sections rattachées à la partie par le découpage IA si disponible, sinon correspondance de titre
                        var pn = window.fichePartNodes ? window.fichePartNodes(n, fs.tree, subPartTitle) : null;
                        if (pn && pn.nodes.length) nodes = pn.nodes;
                        else { var node = window.findFichePart(fs.tree, subPartTitle); if (node) nodes = (node.c && node.c.length) ? node.c : [node]; }
                    }
                    outline = window.outlineLines(nodes, 3).join('\n');
                }
                var map = d ? partMap(n, 'notions') : null;
                var inScope = function (key) { if (part == null || !map) return true; var p = map[key]; return p === undefined || p === part || p < 0; };
                if (!outline && d && d._notions.length) {
                    // pas de fiche EDN (quiz transversaux) : le plan est reconstruit à partir des notions des QCM, par chapitre
                    var byChap = {};
                    d._notions.filter(function (x) { return inScope(x.key); }).forEach(function (x) { var c = x.chap || 'Autres'; (byChap[c] = byChap[c] || []).push(x); });
                    outline = Object.keys(byChap).sort().map(function (c, i) { return (i + 1) + '. ' + c.replace(/^\d+-/, '') + '\n' + byChap[c].map(function (x) { return '   - ' + x.title + (x.rang ? ' [rang ' + x.rang + ']' : ''); }).join('\n'); }).join('\n');
                }
                var notionTitles = d ? d._notions.filter(function (x) { return inScope(x.key); }).map(function (x) { return x.title; }) : [];
                // Points faibles, QCM ratés et lacunes : ceux du périmètre seulement (sous-partie ou renforcement
                // pédiatrie) ; l'item entier prend tout.
                var weak = weakestNotions(n, 40, { part: part, pedia: S.qcm.pedia }).filter(function (x) { return inScope(x.key); }).slice(0, 12).map(function (x) { return { title: x.title, rang: x.rang, mastery: x.mastery, n: x.n }; });
                var failed = failedQuestionsDetail(n, part, d, map, 14);
                var gaps = itemGaps(n, part, S.qcm.pedia).slice(0, 12).map(function (g) { return { titre: g.titre, detail: g.detail, type: g.type || 'manque', ecrit: g.ecrit || '' }; });
                // Les cartes sont demandées par petits lots : une requête longue est coupée par le serveur web
                // (« Request Timeout ») avant que l'IA ait fini. Les rectos déjà écrits sont renvoyés pour éviter les doublons.
                var send = function (ficheText) {
                    var matieres = itemMatieres(n), LOT = 4;
                    var lots = Math.max(1, Math.ceil(count / LOT)), recues = [], meta = null;
                    // Relevé fait UNE fois, avant le premier lot : ce que l'étudiant possède déjà sur cet item.
                    var dejaVues = window.cartesDejaVues(n, part);
                    S.qcm.aiProgress = lots > 1 ? { fait: 0, total: lots } : null;
                    var finir = function (avertissement) {
                        S.qcm.busy = ''; S.qcm.aiProgress = null;
                        if (S.qcm.flash !== f) { render(); return; }
                        var key = deckKey(n, part);
                        var deck = S.learning.decks[key] || (S.learning.decks[key] = { n: n, part: part, created: Date.now(), cards: [] });
                        var now = Date.now();
                        // Dernier filet : une carte qui teste un fait déjà présent dans un deck de cet item n'entre pas.
                        var dedans = {};
                        (deck.cards || []).forEach(function (c) { var e = empreinteCarte(c.recto); if (e) dedans[e] = 1; });
                        var ignorees = 0;
                        recues = recues.filter(function (c) {
                            var e = empreinteCarte(c.recto);
                            if (carteDoublon(e, dedans) || carteDoublon(e, dejaVues.empreintes)) { ignorees++; return false; }
                            if (e) dedans[e] = 1;
                            return true;
                        });
                        recues.forEach(function (c, i) {
                            var id = 'c' + now.toString(36) + i.toString(36) + Math.random().toString(36).slice(2, 6);
                            deck.cards.push({ id: id, recto: c.recto, verso: c.verso, notion: c.notion || '', section: c.section || '', rang: c.rang || 'A', explication: c.explication || '', origine: c.origine || '', created: now, due: now, ivl: 0, reps: 0, lapses: 0 });
                        });
                        deck.updated = now; deck.lastMode = mode;
                        if (mode === 'weak') deck.lastWeakAt = now;
                        window.saveLearning();
                        f.queue = dueCards(deck); f.idx = 0; f.flipped = false; f.results = []; f.all = false;
                        var srcBits = [meta && meta.source === 'pdf' ? 'la fiche EDN complète' : (meta && meta.source === 'outline') ? 'le plan de la fiche' : 'les notions des QCM'];
                        if (meta && meta.college && meta.college.length) srcBits.push('le' + (meta.college.length > 1 ? 's' : '') + ' collège' + (meta.college.length > 1 ? 's' : '') + ' ' + collegeLabel(meta.college));
                        var nQ = recues.filter(function (c) { return c.origine === 'qcm'; }).length;
                        var failedUsed = meta ? meta.failed_used : 0;
                        S.qcm.notice = avertissement
                            ? { type: 'warn', text: recues.length + ' cartes ajoutées, puis interruption : ' + avertissement + ' Relance pour en obtenir davantage' + (/imeout|trop long/i.test(avertissement) ? ', ou demande moins de cartes à la fois.' : '.') }
                            : { type: 'ok', text: recues.length + ' carte' + (recues.length > 1 ? 's ajoutées' : ' ajoutée') + (ignorees ? ' (' + ignorees + ' écartée' + (ignorees > 1 ? 's' : '') + ' : déjà dans ton deck)' : '') + ' (' + (mode === 'weak' ? 'points faibles' : 'découverte') + (S.qcm.pedia ? ', angle pédiatrie' : '') + ', à partir de ' + srcBits.join(' + ') + ')' + (mode === 'weak' && failedUsed ? ' · ' + failedUsed + ' QCM raté' + (failedUsed > 1 ? 's' : '') + ' analysé' + (failedUsed > 1 ? 's' : '') + (nQ ? ' → ' + nQ + ' carte' + (nQ > 1 ? 's ciblent' : ' cible') + ' tes erreurs de QCM' : '') : '') + '.' };
                        render();
                    };
                    var etape = function (k) {
                        var reste = count - recues.length;
                        if (k >= lots || reste <= 0) { finir(null); return; }
                        postApi({ action: 'ai_flashcards', itemNumber: n, itemTitle: itemTitle(n), subPartTitle: subPartTitle, mode: mode, count: Math.min(LOT, reste), outline: outline, ficheText: ficheText, weakNotions: weak, failedQuestions: failed, gaps: gaps, notionTitles: notionTitles, matieres: matieres, pedia: !!S.qcm.pedia, existing: dejaVues.rectos.concat(recues.map(function (c) { return c.recto; })).slice(0, 60), coveredNotions: dejaVues.notions }, function (res) {
                            if (S.qcm.flash !== f) { S.qcm.busy = ''; S.qcm.aiProgress = null; return; }
                            if (!res.success) {
                                // Clé manquante : le serveur nomme le fournisseur (Anthropic ou Mammouth) ; le texte en dur n'est qu'un repli.
                                var msg = res.message || (res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : 'Échec de la génération');
                                if (recues.length) { finir(msg); return; }
                                S.qcm.busy = ''; S.qcm.aiProgress = null; S.qcm.notice = { type: 'error', text: msg }; render(); return;
                            }
                            meta = meta || res;
                            recues = recues.concat(res.cards || []);
                            S.qcm.aiProgress = lots > 1 ? { fait: k + 1, total: lots } : null; render();
                            if (!(res.cards || []).length) { finir(null); return; } // plus rien de neuf à écrire
                            etape(k + 1);
                        }, function (e) { if (recues.length) finir(e.message); else { S.qcm.busy = ''; S.qcm.aiProgress = null; S.qcm.notice = { type: 'error', text: e.message }; render(); } });
                    };
                    etape(0);
                };
                if (mode === 'discovery') chronoText(n, send); else send('');
            });
        });
    };

    // ------------------------------------------------------------------ mini-cours IA ciblé sur les points faibles (source : fiche EDN PDF)
    function coursPoints(n, part, origin) {
        var pts = [];
        if (origin === 'recall' && S.qcm.recall && S.qcm.recall.ai) S.qcm.recall.ai.pointsFaibles.forEach(function (pf) { pts.push({ titre: pf.titre, detail: pf.detail || '', type: pf.type === 'erreur' ? 'erreur' : 'manque' }); });
        itemGaps(n, part).forEach(function (g) { if (!pts.some(function (p) { return nrm(p.titre) === nrm(g.titre); })) pts.push({ titre: g.titre, detail: g.detail || '', type: g.type || 'manque', ecrit: g.ecrit || '' }); });
        pts.sort(function (a, b) { return (b.type === 'erreur' ? 1 : 0) - (a.type === 'erreur' ? 1 : 0); });
        return pts.slice(0, 12);
    }
    window.actions.coursOpen = function (n, part, origin) {
        n = String(n);
        S.qcm.current = n; S.qcm.part = (part === '' || part == null) ? null : parseInt(part, 10); finReunion();
        S.qcm.view = 'cours'; S.qcm.notice = null; S.activeTab = 'qcm';
        S.qcm.cours = { n: n, part: S.qcm.part, points: coursPoints(n, S.qcm.part, origin) };
        window.loadQcmItem(n, function () { if (S.qcm.view === 'cours') render(); });
        if (S.collegeStatus && !S.collegeStatus[n] && window.podcastApi) {
            window.podcastApi({ action: 'college_status', itemNumber: n, matieres: itemMatieres(n), pedia: false }).then(function (d) { if (d && d.success) { S.collegeStatus[n] = d; if (S.qcm.view === 'cours') render(); } }).catch(function () { });
        }
        window.renderHeader(); window.renderContent(); window.scrollTo(0, 0);
    };
    window.actions.coursGenerate = function () {
        if (!ia()) { refusIA(); return; }
        var c = S.qcm.cours; if (!c || S.qcm.busy) return;
        var n = c.n, part = c.part, parts = partsFor(n), d = S.qcm.items[n];
        var map = d ? partMap(n, 'notions') : null;
        var inScope = function (key) { if (part == null || !map) return true; var p = map[key]; return p === undefined || p === part || p < 0; };
        var weak = weakestNotions(n, 40).filter(function (x) { return inScope(x.key) && x.mastery < 0.7; }).slice(0, 10).map(function (x) { return { title: x.title, rang: x.rang, mastery: x.mastery, n: x.n }; });
        var failed = failedQuestionsDetail(n, part, d, map, 10);
        var cards = weakFlashcards(n, part, 10);
        if (!c.points.length && !weak.length && !failed.length && !cards.length) { S.qcm.notice = { type: 'warn', text: 'Aucun point faible connu : réponds à des QCM, révise tes flashcards ou fais un active recall analysé par l\'IA d\'abord.' }; render(); return; }
        // Le cours est écrit par lots de 3 points : une requête longue est coupée par le serveur web avant la fin.
        var lots = [];
        for (var i = 0; i < c.points.length; i += 3) lots.push({ points: c.points.slice(i, i + 3) });
        if (!lots.length) lots.push({ points: [] });
        S.qcm.busy = 'cours'; S.qcm.notice = null; S.qcm.aiProgress = lots.length > 1 ? { fait: 0, total: lots.length } : null; render();
        var sections = [], entete = null, conclusion = '', meta = null;
        var finir = function (avertissement) {
            S.qcm.busy = ''; S.qcm.aiProgress = null;
            if (!sections.length) { S.qcm.notice = { type: 'error', text: avertissement || 'Mini-cours vide' }; render(); return; }
            var cours = { titre: (entete && entete.titre) || itemTitle(n), intro: (entete && entete.intro) || '', sections: sections, conclusion: conclusion };
            S.learning.cours[deckKey(n, part)] = { updated: Date.now(), cours: cours, points: c.points, weak: weak, source: meta ? meta.source : 'none', college: (meta && meta.college) || [], failedUsed: (meta && meta.failed_used) || 0, cardsUsed: (meta && meta.cards_used) || 0 };
            window.saveLearning();
            var srcBits = [(meta && meta.source === 'pdf') ? 'la fiche EDN complète' : 'les connaissances générales (pas de fiche PDF, à vérifier)'];
            if (meta && meta.college && meta.college.length) srcBits.push('le' + (meta.college.length > 1 ? 's' : '') + ' collège' + (meta.college.length > 1 ? 's' : '') + ' ' + collegeLabel(meta.college));
            var used = [];
            if (meta && meta.failed_used) used.push(meta.failed_used + ' QCM raté' + (meta.failed_used > 1 ? 's' : ''));
            if (meta && meta.cards_used) used.push(meta.cards_used + ' flashcard' + (meta.cards_used > 1 ? 's' : '') + ' non acquise' + (meta.cards_used > 1 ? 's' : ''));
            S.qcm.notice = avertissement
                ? { type: 'warn', text: sections.length + ' sections écrites, puis interruption : ' + avertissement + ' Relance pour compléter le cours.' }
                : { type: 'ok', text: 'Mini-cours généré à partir de ' + srcBits.join(' + ') + (used.length ? ' · ' + used.join(' et ') + ' analysé' + (((meta && meta.failed_used) || 0) + ((meta && meta.cards_used) || 0) > 1 ? 's' : '') : '') + '.' };
            render(); window.scrollTo(0, 0);
        };
        var etape = function (k) {
            if (k >= lots.length) { finir(null); return; }
            var premier = k === 0, dernier = k === lots.length - 1;
            postApi({ action: 'ai_mini_cours', itemNumber: n, itemTitle: itemTitle(n), subPartTitle: (part != null && parts) ? parts[part] : '',
                points: lots[k].points, weakNotions: premier ? weak : [], failedQuestions: premier ? failed : [], failedCards: premier ? cards : [],
                matieres: itemMatieres(n), avecIntro: premier, avecConclusion: dernier }, function (res) {
                if (S.qcm.cours !== c) { S.qcm.busy = ''; S.qcm.aiProgress = null; return; }
                if (!res.success) {
                    var msg = res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : (res.message || 'Échec de la génération');
                    finir(msg); return;
                }
                meta = meta || res;
                var k2 = res.cours || {};
                if (premier) entete = { titre: k2.titre, intro: k2.intro };
                sections = sections.concat(k2.sections || []);
                if (k2.conclusion) conclusion = k2.conclusion;
                S.qcm.aiProgress = lots.length > 1 ? { fait: k + 1, total: lots.length } : null; render();
                etape(k + 1);
            }, function (e) { finir(e.message); });
        };
        etape(0);
    };

    // ------------------------------------------------------------------ dictaphone (active recall)
    // Reconnaissance vocale du navigateur (Web Speech API, fr-FR). Le modèle générique écorche le vocabulaire médical :
    // le texte dicté est donc recalé sur les termes réellement attendus, qui sont déjà chargés — ceux de la fiche du
    // podcast en cours et les notions de l'item — complétés d'un petit lexique EDN et de règles d'unités et de chiffres.
    var MED_LEXIQUE = ['clarté nucale', 'trisomie 21', 'PAPP-A', 'β-hCG libre', 'hCG', 'DPNI', 'caryotype', 'amniocentèse',
        'choriocentèse', 'échographie', 'aménorrhée', 'grossesse extra-utérine', 'pré-éclampsie', 'protéinurie', 'albuminurie',
        'diabète gestationnel', 'hématome rétroplacentaire', 'placenta prævia', 'césarienne', 'nouveau-né', 'nourrisson',
        'prématurité', 'dyspnée', 'tachycardie', 'bradycardie', 'hypertension artérielle', 'hypotension', 'œdème',
        'embolie pulmonaire', 'thrombose veineuse profonde', 'D-dimères', 'angioscanner', 'électrocardiogramme',
        'échocardiographie', 'fibrillation atriale', 'insuffisance rénale', 'insuffisance cardiaque', 'protéinurie',
        'numération formule sanguine', 'ionogramme', 'créatininémie', 'kaliémie', 'natrémie', 'glycémie', 'hémoglobine',
        'plaquettes', 'leucocytes', 'lymphocytes', 'polynucléaires', 'CRP', 'TSH', 'ferritinémie', 'bilirubine',
        'transaminases', 'antibiothérapie', 'amoxicilline', 'amoxicilline-acide clavulanique', 'ceftriaxone', 'céfixime',
        'azithromycine', 'doxycycline', 'métronidazole', 'paracétamol', 'ibuprofène', 'aspirine', 'corticoïdes',
        'corticothérapie', 'héparine de bas poids moléculaire', 'anticoagulant', 'antiagrégant plaquettaire',
        'insuline', 'metformine', 'oxygénothérapie', 'vaccination', 'sérovaccination', 'immunoglobulines',
        'contre-indication', 'posologie', 'surveillance', 'diagnostic différentiel', 'conduite à tenir', 'facteur de risque'];
    // unités, comparateurs et tournures dictées à l'oral → écriture compacte de la fiche
    var DICT_REGLES = [
        [/\bsemaines? d(?:'|’)?am[ée]norrh[ée]e\b/gi, 'SA'], [/\bsemaines? d(?:'|’)?am[ée]norr[ée]e?\b/gi, 'SA'],
        [/\bmilligrammes? par kilo(?:gramme)?s?\b/gi, 'mg/kg'], [/\bmilligrammes?\b/gi, 'mg'],
        [/\bmicrogrammes?\b/gi, 'µg'], [/\bgrammes?\b/gi, 'g'], [/\bmillilitres?\b/gi, 'mL'], [/\blitres?\b/gi, 'L'],
        [/\bpour cent\b/gi, ' %'], [/\bpourcent\b/gi, ' %'],
        [/\bsup[ée]rieure?s?\s+(?:ou\s+[ée]gale?s?\s+)?(?:à|a)(?=\s|$)/gi, '>'], [/\binf[ée]rieure?s?\s+(?:ou\s+[ée]gale?s?\s+)?(?:à|a)(?=\s|$)/gi, '<'],
        [/\bplus ou moins\b/gi, '±'], [/\bpremier trimestre\b/gi, '1er trimestre'], [/\bdeuxi[èe]me trimestre\b/gi, '2e trimestre'],
        [/\btroisi[èe]me trimestre\b/gi, '3e trimestre']
    ];
    var DICT_NOMBRES = { zero: 0, un: 1, une: 1, deux: 2, trois: 3, quatre: 4, cinq: 5, six: 6, sept: 7, huit: 8, neuf: 9,
        dix: 10, onze: 11, douze: 12, treize: 13, quatorze: 14, quinze: 15, seize: 16, vingt: 20, trente: 30, quarante: 40,
        cinquante: 50, soixante: 60, cent: 100, mille: 1000 };
    function dictDistance(a, b) { // Levenshtein, borné : sert seulement à repérer un mot mal transcrit
        if (a === b) return 0;
        var m = a.length, n = b.length; if (Math.abs(m - n) > 3) return 9;
        var prev = [], cur = [], i, j;
        for (j = 0; j <= n; j++) prev[j] = j;
        for (i = 1; i <= m; i++) {
            cur[0] = i;
            for (j = 1; j <= n; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1));
            for (j = 0; j <= n; j++) prev[j] = cur[j];
        }
        return prev[n];
    }
    // vocabulaire attendu ici et maintenant : fiche du podcast en cours + notions de l'item + lexique EDN
    window.dictVocabulaire = function () {
        var out = [], seen = {};
        var add = function (t) {
            t = String(t || '').trim(); if (t.length < 3) return;
            var k = nrm(t); if (!k || seen[k]) return; seen[k] = 1; out.push({ k: k, t: t, n: k.split(' ').length });
        };
        var r = S.qcm.recall;
        if (r && r.all) r.all.forEach(function (sec) {
            add(sec.label);
            (sec.items || []).concat(sec.aRetenir || [], sec.piege ? [sec.piege] : []).forEach(function (line) {
                // chaque ligne de fiche fournit ses mots « longs » et ses groupes de deux mots
                var w = String(line).split(/[\s,;:().]+/).filter(Boolean);
                w.forEach(function (x, i) { if (x.length >= 5) add(x); if (i + 1 < w.length && (x.length + w[i + 1].length) >= 9) add(x + ' ' + w[i + 1]); });
            });
        });
        var d = r && S.qcm.items[r.n];
        if (d) (d._notions || []).forEach(function (x) { add(x.title); });
        MED_LEXIQUE.forEach(add);
        return out.sort(function (a, b) { return b.n - a.n; }); // groupes les plus longs d'abord
    };
    // Recale une transcription brute sur le vocabulaire médical, applique unités et comparateurs.
    window.medicalFix = function (texte, vocab) {
        var out = String(texte || '');
        vocab = vocab || window.dictVocabulaire();
        DICT_REGLES.forEach(function (rg) { out = out.replace(rg[0], rg[1]); });
        // « un sur cinquante » / « 1 sur 50 » → 1/50
        out = out.replace(/\b([a-zéèêà]+|\d+)\s+sur\s+([a-zéèêà]+|\d+)\b/gi, function (all, a, b) {
            var na = /^\d+$/.test(a) ? +a : DICT_NOMBRES[nrm(a)], nb = /^\d+$/.test(b) ? +b : DICT_NOMBRES[nrm(b)];
            return (na != null && nb != null) ? na + '/' + nb : all;
        });
        // mot à mot : on remplace un terme mal transcrit par le terme attendu le plus proche
        var mots = out.split(/(\s+)/);
        for (var i = 0; i < mots.length; i += 2) {
            for (var span = 3; span >= 1; span--) {
                var idx = i + (span - 1) * 2; if (idx >= mots.length) continue;
                var brut = mots.slice(i, idx + 1).join('');
                // « l'amoxicilline » : l'élision et la ponctuation encadrantes sont mises de côté puis rendues telles quelles
                var mPre = brut.match(/^(?:[«"(\[]\s*)*(?:[a-zA-Zà-ÿ]{1,2}['’])?/), pre = mPre ? mPre[0] : '';
                var reste = brut.slice(pre.length);
                var mPost = reste.match(/[.,;:!?»)\]]+$/), post = mPost ? mPost[0] : '';
                var coeur = post ? reste.slice(0, -post.length) : reste;
                var key = nrm(coeur);
                if (!key || key.length < 4) continue;
                if (/\d/.test(key)) continue;                 // chiffres, doses et ratios : jamais approchés
                if (span === 1 && STOP[key]) continue;         // mots outils : jamais corrigés
                var best = null, bestD = 99;
                for (var v = 0; v < vocab.length; v++) {
                    var e = vocab[v]; if (e.n !== span) continue;
                    if (e.k === key) { best = null; bestD = 0; break; } // déjà correct
                    var lim = key.length >= 9 ? 3 : (key.length >= 6 ? 2 : 1);
                    var dd = dictDistance(key, e.k);
                    if (dd <= lim && dd < bestD) { bestD = dd; best = e; }
                }
                if (bestD === 0) break;
                if (best) {
                    mots[i] = pre + best.t + post;
                    for (var k = i + 1; k <= idx; k++) mots[k] = '';
                    break;
                }
            }
        }
        return mots.join('').replace(/\s+/g, ' ').replace(/\s+([.,;:!?])/g, '$1').trim();
    };
    // --- micro ---
    var dictRec = null, dictWanted = false;
    function dictSet(on, err) { S.qcm.dict = { on: on, interim: on ? (S.qcm.dict || {}).interim || '' : '', error: err || '' }; render(); }
    window.actions.dictToggle = function () {
        if (dictWanted) { dictWanted = false; if (dictRec) { try { dictRec.stop(); } catch (e) { } } dictRec = null; dictSet(false); return; }
        var Rec = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!Rec) { dictSet(false, "Ton navigateur ne sait pas transcrire la parole. Sur iPhone et iPad, utilise Safari ; sur ordinateur, Chrome ou Edge."); return; }
        var rec = new Rec();
        rec.lang = 'fr-FR'; rec.continuous = true; rec.interimResults = true; rec.maxAlternatives = 1;
        rec.onresult = function (ev) {
            var r = S.qcm.recall; if (!r) return;
            var vocab = window.dictVocabulaire(), fini = '', encours = '';
            for (var i = ev.resultIndex; i < ev.results.length; i++) {
                var t = ev.results[i][0].transcript;
                if (ev.results[i].isFinal) fini += t; else encours += t;
            }
            if (fini.trim()) window.dictAppend(window.medicalFix(fini, vocab));
            S.qcm.dict = { on: true, interim: encours.trim(), error: '' };
            var el = document.getElementById('dict-interim'); if (el) el.textContent = encours.trim();
        };
        rec.onerror = function (ev) {
            if (ev.error === 'no-speech' || ev.error === 'aborted') return; // silence : la relance suffit
            dictWanted = false; dictRec = null;
            dictSet(false, ev.error === 'not-allowed' || ev.error === 'service-not-allowed'
                ? "Micro refusé : autorise le microphone pour ce site dans les réglages du navigateur."
                : "Reconnaissance vocale interrompue (" + ev.error + ").");
        };
        rec.onend = function () { if (dictWanted && dictRec === rec) { try { rec.start(); } catch (e) { } } }; // le navigateur coupe après un silence
        dictRec = rec; dictWanted = true;
        try { rec.start(); } catch (e) { dictWanted = false; dictRec = null; dictSet(false, "Micro indisponible : " + e.message); return; }
        dictSet(true);
    };
    window.dictStopIfOn = function () { if (dictWanted) window.actions.dictToggle(); };
    // Ajoute le texte dicté à la fin des notes, sans re-rendu (le curseur et le défilement seraient perdus)
    window.dictAppend = function (texte) {
        var r = S.qcm.recall; if (!r || !texte) return;
        var ta = document.getElementById('recall-notes');
        var base = ta ? ta.value : (r.notes || '');
        var sep = base && !/\s$/.test(base) ? ' ' : '';
        var val = base + sep + texte;
        if (ta) ta.value = val;
        r.notes = val; recallSaveSoon(r);
    };

    // Brouillon de séance d'active recall : tout ce qui est tapé est enregistré dans le navigateur au fil de l'eau, pour
    // qu'un plantage, une fermeture d'onglet ou une panne de base ne fasse rien perdre. Le brouillon contient aussi les
    // points de la fiche, ce qui permet de continuer la séance même si le serveur ne répond plus. Il est effacé dès que
    // l'analyse IA a réussi : à ce moment tout est déjà dans le journal d'apprentissage (serveur + navigateur).
    var RECALL_DRAFTS = 'edn_recall_drafts_v1', RECALL_MAX_AGE = 7 * 86400000;
    function recallDraftKey(r) { return String(r.n) + '#' + (r.part == null ? '' : r.part) + (r.pedia ? '#ped' : ''); }
    function recallDraftsAll() { try { return JSON.parse(localStorage.getItem(RECALL_DRAFTS) || '{}') || {}; } catch (e) { return {}; } }
    function recallDraftsWrite(all) {
        // on ne garde que les 6 brouillons les plus récents, et rien de plus vieux qu'une semaine
        var now = Date.now();
        var keys = Object.keys(all).filter(function (k) { return all[k] && now - (all[k].t || 0) < RECALL_MAX_AGE; })
            .sort(function (a, b) { return (all[b].t || 0) - (all[a].t || 0); }).slice(0, 6);
        var out = {}; keys.forEach(function (k) { out[k] = all[k]; });
        // quota : le brouillon est un confort, jamais bloquant — storageSet fait de la place et n'échoue pas bruyamment
        if (window.storageSet) window.storageSet(RECALL_DRAFTS, JSON.stringify(out));
        else try { localStorage.setItem(RECALL_DRAFTS, JSON.stringify(out)); } catch (e) {}
    }
    window.recallSaveDraft = function (r) {
        if (!r || !r.all || !r.all.length) return;
        var all = recallDraftsAll();
        all[recallDraftKey(r)] = { t: Date.now(), n: r.n, part: r.part, pedia: !!r.pedia, title: r.title || '', explicatif: r.explicatif,
            all: r.all, idx: r.idx, revealed: !!r.revealed, notes: r.notes || '',
            results: (r.results || []).map(function (x) { return { si: x.si == null ? r.all.indexOf(x.sec) : x.si, score: x.score, notes: x.notes || '', ai: x.ai || null }; }) };
        recallDraftsWrite(all);
    };
    var recallSaveTimer = null;
    function recallSaveSoon(r) { if (recallSaveTimer) clearTimeout(recallSaveTimer); recallSaveTimer = setTimeout(function () { recallSaveTimer = null; window.recallSaveDraft(r); }, 400); }
    function recallDropDraft(r) { var all = recallDraftsAll(); delete all[recallDraftKey(r)]; recallDraftsWrite(all); }
    function recallLoadDraft(r) {
        var d = recallDraftsAll()[recallDraftKey(r)];
        if (!d || !d.all || !d.all.length || Date.now() - (d.t || 0) > RECALL_MAX_AGE) return null;
        return d;
    }
    function recallApplyDraft(r, d) {
        r.all = d.all; r.title = d.title || itemTitle(r.n); r.explicatif = d.explicatif; r.source = 'podcast'; r.noFiche = false;
        r.idx = d.idx || 0; r.revealed = !!d.revealed; r.notes = d.notes || '';
        r.results = (d.results || []).map(function (x) { return { si: x.si, sec: d.all[x.si] || d.all[0], score: x.score, notes: x.notes || '', ai: x.ai || null }; }).filter(function (x) { return x.sec; });
        if (r.results.some(function (x) { return x.ai; })) r.ai = { points: [], pointsFaibles: [], t: d.t };
    }
    // L'active recall s'appuie UNIQUEMENT sur la fiche à suivre du podcast du périmètre (item, sous-partie ou renforcement
    // pédiatrie) : chaque section de la fiche = un point à réciter, avec sa consigne (ce qu'il faut restituer) ; le récap des
    // chiffres forme le dernier point. Sans fiche, on propose de la créer (script requis) ou de générer le podcast d'abord.
    window.actions.recallOpen = function (n, part) {
        if (window.dictStopIfOn) window.dictStopIfOn();
        n = String(n);
        S.qcm.current = n; S.qcm.part = (part === '' || part == null) ? null : parseInt(part, 10); finReunion();
        S.qcm.view = 'recall'; S.qcm.notice = null; S.activeTab = 'qcm';
        var r = S.qcm.recall = { n: n, part: S.qcm.part, pedia: !!S.qcm.pedia, loading: true, error: null, all: null, idx: 0, revealed: false, results: [], notes: '' };
        var draft = recallLoadDraft(r);
        if (draft) {
            // séance interrompue retrouvée dans le navigateur : on la réaffiche telle quelle, sans attendre le serveur
            recallApplyDraft(r, draft); r.loading = false; r.resumed = true;
            S.qcm.notice = { type: 'ok', text: 'Séance reprise là où tu t\'étais arrêté (' + (r.results.length) + ' point' + (r.results.length > 1 ? 's' : '') + ' déjà noté' + (r.results.length > 1 ? 's' : '') + (r.notes ? ', notes en cours conservées' : '') + '). « Recommencer » repart de zéro.' };
        }
        window.loadQcmItem(n, function () { });
        window.renderHeader(); window.renderContent(); window.scrollTo(0, 0);
        recallLoadFiche(r);
    };
    function recallScopePayload(r) { var parts = partsFor(r.n); return { itemNumber: r.n, subPartTitle: (r.part != null && parts) ? parts[r.part] : '', pedia: !!r.pedia }; }
    function recallLoadFiche(r) {
        if (!r.resumed) { r.loading = true; render(); }
        // serveur injoignable (réseau ou base hors service) : la séance reprise continue sur le brouillon local
        var offline = function (msg) {
            if (S.qcm.recall !== r) return;
            r.loading = false;
            if (r.resumed && r.all && r.all.length) { r.offline = true; S.qcm.notice = { type: 'warn', text: 'Serveur injoignable : la séance continue depuis la copie enregistrée sur cet appareil. Tes réponses sont conservées ; lance l\'analyse IA quand la connexion revient.' }; }
            else r.error = msg;
            render();
        };
        postApi(Object.assign(recallScopePayload(r), { action: 'recall_fiche' }), function (res) {
            if (S.qcm.recall !== r) return;
            r.loading = false;
            if (!res.success) { offline(res.message || 'Fiche indisponible'); return; }
            r.script = res.script || null; r.podcast = res.podcast || null;
            if (r.resumed) { render(); return; } // séance en cours : on garde les points de la fiche du brouillon
            r.explicatif = res.explicatif;
            if (!res.fiche) { r.all = null; r.noFiche = true; render(); return; }
            r.noFiche = false; r.all = recallPointsFromFiche(res.fiche); r.title = res.fiche.titre || itemTitle(r.n); r.source = 'podcast';
            if (!r.all.length) r.error = 'La fiche à suivre ne contient aucune section.';
            render();
        }, function (e) { offline(e.message); });
    }
    // Une section de la fiche = une question. La question est celle écrite par l'IA pour la section (« consigne ») ;
    // le site ne redécoupe pas et ne fabrique pas de question à partir des points, qui sont la réponse.
    function recallPointsFromFiche(f) {
        var pts = (f.sections || []).map(function (sec, i) {
            var items = (sec.points || []).map(function (pt) { return String(pt); });
            var consigne = (sec.consigne || '').trim() || ('Restitue tout ce que le podcast dit dans cette partie : chiffres, seuils, critères, conduite à tenir (' + items.length + ' point' + (items.length > 1 ? 's' : '') + ' attendu' + (items.length > 1 ? 's' : '') + ').');
            return { label: sec.titre, consigne: consigne, paragraphes: sec.paragraphes || '', nb: items.length, items: items, aRetenir: sec.aRetenir || [], piege: sec.piege || '', kind: 'fiche', idx: i,
                text: items.join('\n') + ((sec.aRetenir || []).length ? '\nÀ retenir : ' + sec.aRetenir.join(' ; ') : '') + (sec.piege ? '\nPiège : ' + sec.piege : '') };
        }).filter(function (p) { return p.nb || p.text; });
        if ((f.recap || []).length) {
            var rows = f.recap.map(function (x) { return x.label + ' : ' + x.valeur; });
            pts.push({ label: 'Récap des chiffres du podcast', kind: 'recap', nb: rows.length, paragraphes: '', items: rows, aRetenir: [], piege: '',
                consigne: 'Donne de mémoire la valeur exacte de chacun de ces ' + f.recap.length + ' éléments : ' + f.recap.map(function (x) { return x.label; }).join(' · ') + '.',
                text: rows.join('\n') });
        }
        return pts;
    }
    // Exposé pour les vérifications : c'est la fonction qui transforme une fiche en points à réciter.
    window.recallPointsFromFiche = recallPointsFromFiche;
    function recallItemCount(etats) {
        var ok = 0, part = 0;
        (etats || []).forEach(function (e) { if (e === 'ok') ok++; else if (e === 'partiel') part++; });
        return { ok: ok, partiel: part, total: (etats || []).length };
    }
    // créer la fiche à suivre depuis l'active recall (le script du podcast doit exister)
    window.actions.recallCreateFiche = function () {
        var r = S.qcm.recall; if (!r || !r.script || S.qcm.busy) return;
        S.qcm.busy = 'recall_fiche'; S.qcm.notice = null; render();
        postApi(Object.assign(recallScopePayload(r), { action: 'podcast_fiche', explicatif: !!r.script.explicatif, itemTitle: itemTitle(r.n) }), function (res) {
            S.qcm.busy = '';
            if (!res.success) { S.qcm.notice = { type: 'error', text: res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : (res.message || 'Échec de la rédaction de la fiche') }; render(); return; }
            if (window.podcastUpsert) window.podcastUpsert(res.podcast);
            S.qcm.notice = { type: 'ok', text: 'Fiche à suivre ' + (res.cached ? 'chargée' : 'rédigée') + ' d\'après le script du podcast : ' + (res.fiche.sections || []).length + ' sections à réciter.' };
            recallLoadFiche(r);
        });
    };
    window.actions.recallOpenPodcast = function () {
        var r = S.qcm.recall; if (!r || !window.actions.openPodcast) return;
        var sc = recallScopePayload(r);
        window.actions.openPodcast(r.n, sc.subPartTitle, sc.pedia, itemMatieres(r.n));
    };
    function recallList(r) {
        var all = r.all || [];
        if (r.showRangC) return all;
        return all.filter(function (sec) { return !window.isRangC(r.n, sec.label); });
    }
    window.actions.recallShowRangC = function (v) { var r = S.qcm.recall; if (!r) return; r.showRangC = !!v; r.idx = 0; r.revealed = false; r.notes = ''; render(); };
    // saisie au fil de l'eau : on garde le texte dans l'état et dans le navigateur, sans re-rendu (le curseur resterait perdu)
    window.actions.recallNotes = function (v) { var r = S.qcm.recall; if (!r) return; r.notes = (v && v.value !== undefined) ? v.value : v; recallSaveSoon(r); };
    window.actions.recallReveal = function () { var r = S.qcm.recall; if (!r) return; window.dictStopIfOn(); var ta = document.getElementById('recall-notes'); if (ta) r.notes = ta.value; r.revealed = true; window.recallSaveDraft(r); render(); };
    window.actions.recallRate = function (score) {
        var r = S.qcm.recall; if (!r) return;
        var list = recallList(r), sec = list[r.idx]; if (!sec) return;
        var notions = [sec.label].concat(matchNotionTitles(r.n, sec.label, sec.text).filter(function (t) { return nrm(t) !== nrm(sec.label); }));
        logEntry({ m: 'recall', i: r.n, q: 'sec:' + nrm(sec.label), s: score, n: notions, nr: notions.map(function () { return null; }), p: r.part, ped: S.qcm.pedia ? 1 : undefined });
        r.results.push({ si: r.all.indexOf(sec), sec: sec, score: score, notes: r.notes || '' });
        r.idx++; r.revealed = false; r.notes = '';
        window.recallSaveDraft(r);
        render(); window.scrollTo(0, 0);
    };
    window.actions.recallSkip = function () { var r = S.qcm.recall; if (!r) return; window.dictStopIfOn(); r.idx++; r.revealed = false; r.notes = ''; window.recallSaveDraft(r); render(); };
    window.actions.recallRestart = function () { var r = S.qcm.recall; if (!r) return; r.idx = 0; r.revealed = false; r.results = []; r.ai = null; r.notes = ''; r.resumed = false; recallDropDraft(r); render(); };
    // Analyse IA de la séance : ce que l'étudiant a écrit de mémoire est comparé à la fiche ; chaque point reçoit un
    // score IA (journalisé comme observation « recall_ai »), et les lacunes prioritaires alimentent flashcards et mini-cours
    // Les points faibles prioritaires sont déduits des erreurs (mémorisé faux : le plus coûteux) puis des manques des
    // sections les moins bien restituées. Pas d'appel IA supplémentaire : chaque requête doit rester courte, le serveur
    // coupant les requêtes trop longues (« Request Timeout »).
    function recallDerivePointsFaibles(results) {
        var out = [], vu = {};
        var court = function (t) { t = String(t || '').trim(); return t.length > 90 ? t.slice(0, 87) + '…' : t; };
        results.forEach(function (x) {
            ((x.ai && x.ai.erreurs) || []).forEach(function (e) {
                var t = court(e.correct); if (!t || vu[nrm(t)]) return; vu[nrm(t)] = 1;
                out.push({ type: 'erreur', titre: t, detail: e.pourquoi || '', sec: nrm(x.sec.label) });
            });
        });
        results.slice().sort(function (a, b) { return ((a.ai ? a.ai.score : 1) - (b.ai ? b.ai.score : 1)); }).forEach(function (x) {
            ((x.ai && x.ai.manques) || []).forEach(function (m) {
                if (out.length >= 8) return;
                var t = court(m); if (!t || vu[nrm(t)]) return; vu[nrm(t)] = 1;
                out.push({ type: 'manque', titre: t, detail: x.sec.label, sec: nrm(x.sec.label) });
            });
        });
        return out;
    }
    // ------------------------------------------------------------------ bilan du soir
    // Reprendre le soir même, en QCM ou en flashcards, tout ce qui a été coché dans la journée. Le moteur de
    // séance ne sait traiter qu'un item à la fois : le bilan est donc une FILE d'attente posée par-dessus, qui
    // relance une séance par item et tient le compte général. Rien du moteur n'a eu à changer pour ça.
    window.soirLancerCourant = function () {
        var b = S.qcm.soir; if (!b) return;
        if (b.i >= b.file.length) { S.qcm.view = 'soirFin'; S.activeTab = 'qcm'; window.renderHeader(); window.renderContent(); window.scrollTo(0, 0); return; }
        var e = b.file[b.i];
        S.qcm.pedia = !!e.pedia;
        if (b.mode === 'flash') {
            window.actions.flashOpen(e.n, e.part == null ? '' : e.part, false);
            // Pas une carte à revoir sur cet item : on n'affiche pas un écran vide, on passe au suivant.
            if (!S.qcm.flash || !S.qcm.flash.queue.length) { window.soirSauter('aucune carte à revoir'); return; }
        } else {
            window.actions.qcmStartSession(e.n, 'adaptive', e.part == null ? '' : e.part, 10);
        }
    };
    window.soirSauter = function (raison) {
        var b = S.qcm.soir; if (!b) return;
        var e = b.file[b.i];
        if (e) b.sautes.push({ n: e.n, part: e.part, raison: raison });
        b.i++;
        window.soirLancerCourant();
    };
    window.soirCompter = function (resultats) {
        var b = S.qcm.soir; if (!b) return;
        (resultats || []).forEach(function (r) { b.faits++; if (r.score >= 1) b.justes++; });
    };
    window.actions.soirDemarrer = function (mode) {
        var file = window.itemsDuJour(S.tasks, window.todayStr(), S.subParts);
        if (!file.length) {
            S.qcm.notice = { type: 'warn', text: 'Aucune séance cochée aujourd\'hui : il n\'y a rien à revoir ce soir.' };
            S.qcm.view = 'index'; window.soirAllerAuQcm(); return;
        }
        S.qcm.soir = { mode: mode === 'flash' ? 'flash' : 'qcm', file: file, i: 0, faits: 0, justes: 0, sautes: [], debut: Date.now() };
        // Un vrai changement d'onglet AVANT de lancer : le bilan part depuis la page du jour, et l'adresse doit
        // suivre pour que Précédent y ramène et qu'un rechargement reste sur le bilan.
        window.soirAllerAuQcm();
        window.soirLancerCourant();
    };
    window.soirAllerAuQcm = function () {
        if (S.activeTab !== 'qcm' && window.actions.switchTab) window.actions.switchTab('qcm');
        else { S.activeTab = 'qcm'; window.renderHeader(); window.renderContent(); window.scrollTo(0, 0); }
    };
    window.actions.soirSuivant = function () {
        var b = S.qcm.soir; if (!b) return;
        b.i++;
        window.soirLancerCourant();
    };
    window.actions.soirQuitter = function () {
        S.qcm.soir = null; S.qcm.view = 'index'; S.qcm.session = null; S.qcm.flash = null;
        window.renderContent(); window.scrollTo(0, 0);
    };

    function n0(r) { return r.n; }
    // Ce que l'étudiant a écrit, mis en forme pour un correcteur — le même paquet pour l'IA et pour le
    // correcteur local, qui rendent exactement la même chose.
    function recallPointsACorriger(r) {
        var parts = partsFor(r.n);
        return r.results.filter(function (x) { return (x.notes || '').trim() && !window.isRangC(n0(r), x.sec.label); })
            .map(function (x) {
                return { id: 'p' + r.results.indexOf(x), label: x.sec.label, notes: x.notes.slice(0, 1500),
                    items: x.sec.items || [], fiche: x.sec.text.slice(0, 2000), selfScore: x.score, parts: parts };
            });
    }
    // Range une correction — d'où qu'elle vienne — dans la séance, le journal d'apprentissage et les lacunes.
    function recallRangerCorrection(r, recus, source) {
        var n = r.n, now = Date.now(), byId = {};
        recus.forEach(function (p) { byId[p.id] = p; });
        r.results.forEach(function (x, i) {
            var p = byId['p' + i]; if (!p) return;
            x.ai = p;
            var notions = [x.sec.label].concat(p.notions || [], matchNotionTitles(n, x.sec.label)).filter(function (t, k, arr) { return t && arr.map(nrm).indexOf(nrm(t)) === k; });
            logEntry({ m: 'recall_ai', i: n, q: 'sec:' + nrm(x.sec.label), s: p.score, n: notions, nr: notions.map(function () { return null; }), p: r.part, ped: S.qcm.pedia ? 1 : undefined, t: now + i, src: source });
        });
        var faibles = recallDerivePointsFaibles(r.results);
        var gaps = S.learning.gaps[n] = S.learning.gaps[n] || [], seenT = {};
        r.results.forEach(function (x, i) { ((x.ai && x.ai.erreurs) || []).forEach(function (e, k) { var titre = e.correct.length > 90 ? e.correct.slice(0, 87) + '…' : e.correct; if (seenT[nrm(titre)]) return; seenT[nrm(titre)] = 1; gaps.push({ t: now + i * 10 + k, type: 'erreur', titre: titre, detail: (e.pourquoi || '') + (e.ecrit ? ' (tu avais écrit : « ' + e.ecrit + ' »)' : ''), ecrit: e.ecrit || '', point: x.sec.label, sec: nrm(x.sec.label), p: r.part, ped: S.qcm.pedia ? 1 : undefined, src: source }); }); });
        faibles.forEach(function (pf, i) { if (pf && pf.titre && !seenT[nrm(pf.titre)]) { seenT[nrm(pf.titre)] = 1; gaps.push({ t: now + 1000 + i, type: pf.type, titre: pf.titre, detail: pf.detail || '', sec: pf.sec || '', p: r.part, ped: S.qcm.pedia ? 1 : undefined, src: source }); } });
        if (gaps.length > 40) S.learning.gaps[n] = gaps.slice(-40);
        r.ai = { points: recus, pointsFaibles: faibles, source: source, t: now };
        window.saveLearning();
        recallDropDraft(r);
        return { faibles: faibles, now: now };
    }
    // Correction sans IA : instantanée, hors ligne, sans abonnement. Elle coche les points de la fiche à partir
    // du lexique médical (src/domain/qcm/lexique.js) et ne signale que ce qu'on peut établir sans comprendre —
    // un chiffre contredit, une affirmation retournée. Le reste reste le travail de la relecture IA.
    window.actions.recallCorrigerLocal = function () {
        var r = S.qcm.recall; if (!r || S.qcm.busy || !window.corrigerRecallLocal) return;
        var points = recallPointsACorriger(r);
        if (!points.length) { S.qcm.notice = { type: 'warn', text: 'Écris ce que tu retiens avant de révéler chaque point : sans notes, il n\'y a rien à corriger.' }; render(); return; }
        var recus = window.corrigerRecallLocal(points);
        recallRangerCorrection(r, recus, 'local');
        var tot = { ok: 0, partiel: 0, total: 0 };
        r.results.forEach(function (x) { var c = recallItemCount(x.ai && x.ai.items); tot.ok += c.ok; tot.partiel += c.partiel; tot.total += c.total; });
        var nbErr = r.results.reduce(function (a, x) { return a + ((x.ai && x.ai.erreurs) ? x.ai.erreurs.length : 0); }, 0);
        S.qcm.notice = { type: nbErr ? 'error' : 'ok',
            text: 'Correction sans IA : ' + tot.ok + ' / ' + tot.total + ' point' + (tot.total > 1 ? 's' : '') + ' de la fiche coché' + (tot.ok > 1 ? 's' : '')
                + (tot.partiel ? ' (' + tot.partiel + ' à moitié)' : '')
                + (nbErr ? ', ' + nbErr + ' contradiction' + (nbErr > 1 ? 's' : '') + ' repérée' + (nbErr > 1 ? 's' : '') : '')
                + '. Elle reconnaît le vocabulaire, les abréviations, les chiffres et les négations — pas le raisonnement : lance la relecture IA pour ça.' };
        render(); window.scrollTo(0, 0);
    };
    window.actions.recallAnalyse = function () {
        if (!ia()) { refusIA(); return; }
        var r = S.qcm.recall; if (!r || S.qcm.busy) return;
        var withNotes = r.results.filter(function (x) { return (x.notes || '').trim() && !window.isRangC(n0(r), x.sec.label); });
        if (!withNotes.length) { S.qcm.notice = { type: 'warn', text: 'Écris ce que tu retiens avant de révéler chaque point : l\'IA n\'a rien à évaluer sinon.' }; render(); return; }
        var n = r.n, parts = partsFor(n), d = S.qcm.items[n];
        var points = withNotes.map(function (x) { return { id: 'p' + r.results.indexOf(x), label: x.sec.label, notes: x.notes.slice(0, 1500), items: x.sec.items || [], fiche: x.sec.text.slice(0, 2000), selfScore: x.score }; });
        // découpage en petits lots : une requête longue est coupée par le serveur avant d'avoir répondu
        var lots = []; for (var i = 0; i < points.length; i += 3) lots.push(points.slice(i, i + 3));
        S.qcm.busy = 'recall_ai'; S.qcm.aiProgress = { fait: 0, total: lots.length }; S.qcm.notice = null; render();
        var recus = [];
        var termine = function (avertissement) {
            S.qcm.busy = ''; S.qcm.aiProgress = null;
            var now = Date.now(), byId = {};
            recus.forEach(function (p) { byId[p.id] = p; });
            r.results.forEach(function (x, i) {
                var p = byId['p' + i]; if (!p) return;
                x.ai = p;
                var notions = [x.sec.label].concat(p.notions || [], matchNotionTitles(n, x.sec.label)).filter(function (t, k, arr) { return t && arr.map(nrm).indexOf(nrm(t)) === k; });
                logEntry({ m: 'recall_ai', i: n, q: 'sec:' + nrm(x.sec.label), s: p.score, n: notions, nr: notions.map(function () { return null; }), p: r.part, ped: S.qcm.pedia ? 1 : undefined, t: now + i });
            });
            var faibles = recallDerivePointsFaibles(r.results);
            var gaps = S.learning.gaps[n] = S.learning.gaps[n] || [];
            var seenT = {};
            // chaque erreur factuelle devient une lacune de type « erreur » (ce qui a été écrit → le vrai)
            r.results.forEach(function (x, i) { ((x.ai && x.ai.erreurs) || []).forEach(function (e, k) { var titre = e.correct.length > 90 ? e.correct.slice(0, 87) + '…' : e.correct; if (seenT[nrm(titre)]) return; seenT[nrm(titre)] = 1; gaps.push({ t: now + i * 10 + k, type: 'erreur', titre: titre, detail: (e.pourquoi || '') + (e.ecrit ? ' (tu avais écrit : « ' + e.ecrit + ' »)' : ''), ecrit: e.ecrit || '', point: x.sec.label, sec: nrm(x.sec.label), p: r.part, ped: S.qcm.pedia ? 1 : undefined }); }); });
            faibles.forEach(function (pf, i) { if (pf && pf.titre && !seenT[nrm(pf.titre)]) { seenT[nrm(pf.titre)] = 1; gaps.push({ t: now + 1000 + i, type: pf.type, titre: pf.titre, detail: pf.detail || '', sec: pf.sec || '', p: r.part, ped: S.qcm.pedia ? 1 : undefined }); } });
            if (gaps.length > 40) S.learning.gaps[n] = gaps.slice(-40);
            r.ai = { points: recus, pointsFaibles: faibles, source: 'fiche', t: now };
            window.saveLearning();
            recallDropDraft(r); // séance analysée : scores, erreurs et lacunes sont désormais dans le journal d'apprentissage
            var nbErr = r.results.reduce(function (a, x) { return a + ((x.ai && x.ai.erreurs) ? x.ai.erreurs.length : 0); }, 0);
            var tot = { ok: 0, partiel: 0, total: 0 };
            r.results.forEach(function (x) { var c = recallItemCount(x.ai && x.ai.items); tot.ok += c.ok; tot.partiel += c.partiel; tot.total += c.total; });
            var coche = tot.total ? tot.ok + ' / ' + tot.total + ' point' + (tot.total > 1 ? 's' : '') + ' de la fiche coché' + (tot.ok > 1 ? 's' : '') + (tot.partiel ? ' (' + tot.partiel + ' partiel' + (tot.partiel > 1 ? 's' : '') + ')' : '') : '';
            S.qcm.notice = avertissement
                ? { type: 'warn', text: avertissement + ' ' + (coche ? coche + ' sur les sections analysées. ' : '') + 'Relance l\'analyse pour terminer les sections restantes.' }
                : nbErr
                    ? { type: 'error', text: coche + (coche ? '. ' : '') + nbErr + ' erreur' + (nbErr > 1 ? 's' : '') + ' factuelle' + (nbErr > 1 ? 's' : '') + ' détectée' + (nbErr > 1 ? 's' : '') + ' dans tes notes : lis le bloc rouge ci-dessous avant de continuer. Ces erreurs sont en tête de ton profil et seront corrigées en priorité par les flashcards et le mini-cours.' }
                    : { type: 'ok', text: 'Analyse terminée : ' + (coche || recus.length + ' points évalués') + ', aucune erreur factuelle, lacunes ajoutées à ton profil.' };
            render();
        };
        var echec = function (msg) {
            if (S.qcm.recall !== r) { S.qcm.busy = ''; S.qcm.aiProgress = null; return; }
            if (recus.length) { termine('Analyse interrompue (' + msg + ').'); return; } // on garde ce qui a été analysé
            S.qcm.busy = ''; S.qcm.aiProgress = null;
            S.qcm.notice = { type: 'error', text: msg }; render();
        };
        var suite = function (k) {
            if (k >= lots.length) { termine(null); return; }
            postApi({ action: 'ai_recall_analyse', itemNumber: n, itemTitle: itemTitle(n), subPartTitle: (r.part != null && parts) ? parts[r.part] : '', points: lots[k], notionTitles: d ? d._notions.map(function (x) { return x.title; }) : [] }, function (res) {
                if (S.qcm.recall !== r) { S.qcm.busy = ''; S.qcm.aiProgress = null; return; }
                // Clé manquante : le serveur nomme le fournisseur (Anthropic ou Mammouth) ; le texte en dur n'est qu'un repli.
                if (!res.success) { echec(res.message || (res.needs_api_key ? 'Clé API Anthropic non configurée dans api.php.' : 'Échec de l\'analyse IA')); return; }
                recus = recus.concat(res.points || []);
                S.qcm.aiProgress = { fait: k + 1, total: lots.length }; render();
                suite(k + 1);
            }, function (e) { echec(e.message); });
        };
        suite(0);
    };


    // ------------------------------------------------------------------ ce que le module de la page lit ici
    // Un seul point de passage, additif : le module de rendu (src/ui/pages/qcm.js) a besoin de la lecture du
    // journal d'apprentissage, du bareme et du decoupage en sous-parties, qui restent la logique de ce fichier.
    // Decouper cette logique en modules de domaine (src/domain/qcm/*) est le travail du lot de cloture.
    window.scoreQuestion = scoreQuestion;
    window.qcmInterne = {
        ia: ia, admin: admin, pediaArg: pediaArg,
        itemMeta: itemMeta, itemTitle: itemTitle, specOf: specOf, extraItems: extraItems, listRows: listRows,
        itemMatieres: itemMatieres, collegeLabel: collegeLabel, livreParCollege: livreParCollege,
        partsFor: partsFor, partMap: partMap, questionPart: questionPart, questionsForPart: questionsForPart,
        itemMastery: itemMastery, notionStats: notionStats, weakestNotions: weakestNotions,
        itemGaps: itemGaps, newWeakSince: newWeakSince, itemNeverSeen: itemNeverSeen,
        scoreQuestion: scoreQuestion, isMany: isMany, isDefined: isDefined, nbAttendu: nbAttendu, isText: isText, isArea: isArea,
        acceptedAnswers: acceptedAnswers, correctPolys: correctPolys, typeLabel: typeLabel,
        propsForDisplay: propsForDisplay, propsInOrder: propsInOrder, curQ: curQ,
        getDeck: getDeck, dueCards: dueCards, deckKey: deckKey, deckReuni: deckReuni,
        recallList: recallList, recallItemCount: recallItemCount,
        cleanHtml: cleanHtml, stripHtml: stripHtml, imgUrl: imgUrl, nrm: nrm, pct: pct, fmtDate: fmtDate,
        sessionSauvee: sessionSauvee, render: render
    };

    // styles : contenu riche des QCM edn.fr et des fiches chrono
    // Les styles du contenu riche (QCM edn.fr, fiches chrono, corrections LCA) vivent dans src/styles/qcm.css,
    // ecrits sur les jetons : ils suivent le mode jour / nuit.
})();
